import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import fetchAPI from '../../common/fetchAPI';
import moment from 'moment';
import {
    setTimesheetStatus, displayValueForTimeEntry, getStatusByName, getTimeEntryStatus, getProfileSettingForDevelopmentMode, getDecimalFromTime,
    getTimeEntryHoursFormat, getTimesheetApprovalStatus, getTimesheetTimesheetEntered
} from '../../common/timesheetFunction';
import { TimesheetStateClass } from '../../interfaces/TimesheetStateClass';
import { formatNumberCustomoriginalapiv2 } from '../../common/timeLiveFunction';
const { NODE_ENV } = process.env
const initialState: TimesheetStateClass = {
    value: 0,
    status: 'idle',
    employeeList: [],
    isLoading: true,
    accountEmployeeTimeEntryPeriodId: null,
    currentDate: moment().format("YYYY-MM-DD"),
    isCopyTimesheetDate: moment().format("YYYY-MM-DD"),
    startDate: "2023-02-01",
    endDate: "2023-02-07",
    decimalFormat: false,
    isPercentageFormat: false,
    timeEntryViewType: "Weekly",
    timesheetStatus: {
        class: "badge-light-warning",
        text: "Not Submitted"
    },
    isTimesheetPolicy: false,
    showWorkType: true,
    showCostCenter: true,
    showClient: true,
    showTimeEntriesDescription: true,
    accountEmployeeId: 0,
    accountWorkingDayTypeId: '',
    accountWorkTypeId: "0",
    isLocked: false,
    timeEntriesList: [],
    isSubmittedRecordsLocked: false,
    isApprovedRecordsLocked: false,
    numberOfBlankRowsInTimesheet: 2,
    numberOfBlankRowsInTimeOff: 2,
    CurrentCultureDateFormat: 'M/d/yyyy',
    totalHours: "",
    customFieldsTemplate: [],
    isReload: false,
    showClockStartEnd: false,
    timeEntryFormat: 'HH:mm',
    ShowProjectForTimeOff: true,
    ShowProjectTask: true,
    submittedDate: "2023-02-07",
    billableHours: "",
    nonBillableHours: "",
    // isUserImage: false,
    employeeName: '',
    // shortName: '',
    accountId: 0,
    accessToken: "",
    periodDescription: "",
    defaultWorkTypeId: 0,
    todayHours: "",
    // accountFeatureList: [],
    // masterAccountRoleId: 0,
    isHoliday: false,
    isCopyTimesheet: false,
    copyStartDate: "2023-02-01",
    copyEndDate: "2023-02-07",
    tempCopyHeader: [],
    copyTimeEntryAutoSave: false,
    isCopyActivities: false,
    oldTimeEntryViewType: 'Weekly',
    decimalTotalHours: 0,
    isImportedTimesheet: false,
    timeEntryAccountEmployeeId: 0,
    TimeEntryStartDate: moment(new Date()).format("YYYY-MM-DD"),
    TimeEntryEndDate: moment(new Date()).format("YYYY-MM-DD"),
    IncudeDateRange: false,
    AccountProjectId: 0,
    timesheetApprovalList: [],
    isSearch: false,
    pageNo: 1,
    isShowGrid: false,
    search: '',
    pageSize: 10,
    startRec: 0,
    totalItems: 0,
    recordsFiltered: 0,
    isCanvasLoading: false,
    newRecords: [],
    removeRecords: [],
    IsShowEmployeeNameWithCode: false,
    IsShowLockSubmittedRecords: false,
    IsShowLockApprovedRecords: false,
    timerObject: [{ hours: 0, minutes: 0, seconds: 0 }],
    lastEntryTimerId: 0,
    timeEntryIdForTimer: 0,
    hoursRedux: 0,
    minutesRedux: 0,
    secondsRedux: 0,
    autoTimer: false,
    isTimer: false,
    enableTimerInTimesheet: false,
    isShowAttachment: false,
    isLockPreviousTimesheetPeriods: 0,
    dateRangeMode: '',
    showCopyTimesheet: true,
    showCopyActivityTimesheet: true,
    enableOfflineTimesheet: true,
    timesheetSubmissionMessage: '',
    timesheetPrintFooter: '',
    isAllowOverlappingTimeEntries: true,
    includeDateRange: true,
    //PeriodList
    includeDateRangePeriodList: true,
    timesheetApprovalStatusId: 1,
    timesheetEnteredTypeId: 1,
    timesheetPeriodListEmpId: '',
    timeSheetPeriodList: [],
    timesheetFilterStartDate: moment(new Date()).format("YYYY-MM-DD"),
    timesheetFilterEndDate: moment(new Date()).format("YYYY-MM-DD"),
    //TimesheetApprovals
    timesheetApprovalStatusList: getTimesheetApprovalStatus(),
    timesheetEnteredList: getTimesheetTimesheetEntered(),
    timesheetApprovalStartDate: moment().startOf('year').format("YYYY-MM-DD"),
    timesheetApprovalEndDate: moment().endOf('year').format("YYYY-MM-DD"),
    timeoffApprovalList: [],
    approvalAccountProjectId: 0,
    optionApproverEmployeeValue: "0",
    optionApproverEmployeeText: "All",
    projectList: [],
    timesheetPeriodApprovalListEmpId: '',
    timesheetPeriodApprovalListProjectId: '0',
    fromTabIndex: false,
    timeEntryPeriodIdForPrint: '',
    isForTimesheet: true,
    isAttachment: false,
    //Approval Print
    systemApproverTypeForPrint: '',
    startDateForPrint: "2023-02-01",
    endDateForPrint: "2023-02-01",
    rowAccountEmployeeIdForPrint: 0,
    isReloadApproval: false,
    isLoadingApproval: false,
    timesheetApprovalDetailsList: [],
    timeEntryPeriodIdForApproval: '',
    isApprovalDetail: false,
    isSubmitted: false,
    refreshPrint: false,
    timeSheetPeriodIds: [],
    isAllChecked: false,
    showTemplateInTimesheet: false,
    allowZeroHoursInTimesheet: false,
    isTimerCloseWithNoEntry: false,
    IsMyTimeOff: false,
    timerWidgetData: [],
    lockingDateArray: [],
    lockPreviousNextMonthTimesheetOn: 0,
    Employeesdata: [],
    timeEntryAccountEmployeeIds: [],
    showScrollButtons: false,
    isStateHour: false,
    isStateMinute: false,
    noOfWorkingDays: 0,
    refreshApi: false,
    approvalEmployeeName: '',
    workingDayNo:'',
    isTimerPulsing: false
}

export interface IThunkApi {
    state: {
        globalState: any;
        timesheet: TimesheetStateClass;
    },
}

export const getEmployeeAsync = createAsyncThunk
    <
        any,
        void,
        IThunkApi
    >
    (
        'timesheet/getEmployee',
        async (arg, thunkApi) => {
            const { accessToken } = thunkApi.getState().globalState;
            const response = await fetchAPI('api/Timesheets/GetAccountEmployeesForTimesheet/', 'GET', "", true, accessToken);
            const json = await response.json();
            return json;
        }
    )

// export const getEmployeeProfileSettingAsync = createAsyncThunk(
//     'timesheet/getEmployeeProfileSetting',
//     async () => {
//         if (NODE_ENV === "development") {
//             return getProfileSettingForDevelopmentMode();
//         }
//         const response = await fetchAPI('Services/react.svc/GetUserProfileSetting', 'POST', "", false);
//         const json = await response.json();
//         return json;
//     }
// )

// export const getAccountFeatureAsync = createAsyncThunk
//     <
//         any,
//         void,
//         IThunkApi
//     >
//     (
//         'timesheet/getAccountFeature',
//         async (arg, thunkApi) => {
//             const { accountRoleId } = thunkApi.getState().globalState;
//             const response = await fetchAPI(`api/Account/AccountFeatureAndRole/${accountRoleId}`, 'GET', "", true);
//             const json = await response.json();
//             return json;
//         }
//     )

export const getTimer = createAsyncThunk
    <
        any,
        void,
        IThunkApi
    >
    (
        'timesheet/getTimer',
        async (arg, thunkApi) => {
            const { accessToken } = thunkApi.getState().globalState
            const response = await fetchAPI(`api/Timesheets/GetTimer/`, 'GET', "", true, accessToken);
            const json = await response.json();
            return json;
        }
    )

export const getTimesheetPeriodAsync = createAsyncThunk
    <
        any,
        void,
        IThunkApi
    >
    (
        'timesheet/getTimesheetPeriod',
        async (arg, thunkApi) => {
            try {
                const { accountEmployeeId, currentDate, isCopyTimesheet, isCopyTimesheetDate } = thunkApi.getState().timesheet
                const { accessToken } = thunkApi.getState().globalState
                let date = isCopyTimesheet === true ? isCopyTimesheetDate : currentDate
                const response = await fetchAPI(`api/Timesheets/GetTimesheetPeriodForReact/${accountEmployeeId}/${date}`, 'GET', "", true, accessToken);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json;
                // return { ...json, isSubmittedRecordsLocked, isApprovedRecordsLocked };
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const getTimeEntriesByPeriodIdAsync = createAsyncThunk
    <
        any,
        void,
        IThunkApi
    >
    (
        'timesheet/getTimeEntriesByPeriodId',
        async (arg, thunkApi) => {
            try {
                const { accountEmployeeId, startDate, endDate, copyStartDate, copyEndDate, isCopyTimesheet, isTimesheetPolicy, decimalFormat, numberOfBlankRowsInTimesheet, numberOfBlankRowsInTimeOff } = thunkApi.getState().timesheet;
                const { cultureInfoName, decimalplace, accessToken, showTimeOffInTimesheet, timesheetSort } = thunkApi.getState().globalState
                const response = await <any>fetchAPI(`api/Timesheets/GetTimeEntryByEmployeeIdAndDateRange/${accountEmployeeId}/${isCopyTimesheet == false ? startDate : copyStartDate}/${isCopyTimesheet == false ? endDate : copyEndDate}`, 'GET', "", true, accessToken);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return { res: json, isTimesheetPolicy, decimalFormat, numberOfBlankRowsInTimesheet, numberOfBlankRowsInTimeOff, showTimeOffInTimesheet, timesheetSort, cultureInfoName };
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const getCustomFieldTemplateAsync = createAsyncThunk
    <
        any,
        void,
        IThunkApi
    >
    (
        'timesheet/getCustomFieldTemplate',
        async (arg, thunkApi) => {
            try {
                const response = await fetchAPI('api/Timesheets/GetCustomFieldTemplate', 'GET');
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const getTimesheetApprovalsWithFilters = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/getTimesheetApprovalsWithFilters',
        async (arg, thunkApi) => {
            try {
                const { ApproverEmployeeId } = arg;
                const { timeEntryAccountEmployeeIds, accountEmployeeId, timeEntryAccountEmployeeId, timesheetApprovalStartDate, timesheetApprovalEndDate, includeDateRange, approvalAccountProjectId } = thunkApi.getState().timesheet;
                const employeeValues = encodeURIComponent(timeEntryAccountEmployeeIds);
                const response = await fetchAPI(`api/v2/Timesheets/GetTimesheetApprovalsWithFilters/${arg}/${timeEntryAccountEmployeeId}/${timesheetApprovalStartDate}/${timesheetApprovalEndDate}/${includeDateRange}/${approvalAccountProjectId}?EmployeeValues=${employeeValues}`, 'GET', "", true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const getTimeOffApprovalsWithFilters = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/getTimeOffApprovalsWithFilters',
        async (arg, thunkApi) => {
            try {
                const { accountEmployeeId, timeEntryAccountEmployeeId, timesheetApprovalStartDate, timesheetApprovalEndDate, includeDateRange } = thunkApi.getState().timesheet;
                const response = await fetchAPI(`api/V2/Timesheets/getTimeOffApprovalsWithFilters/${arg}/${0}/${timesheetApprovalStartDate}/${timesheetApprovalEndDate}/${includeDateRange}`, 'GET', "", true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const getTimeEntryPeriodListAsync = createAsyncThunk
    <
        any,
        void,
        IThunkApi
    >
    (
        'timesheet/getTimeEntryPeriodList',
        async (arg, thunkApi) => {
            try {
                const { accountEmployeeId, timesheetPeriodListEmpId, timesheetFilterStartDate, startDate, timesheetFilterEndDate, endDate, includeDateRangePeriodList, timesheetApprovalStatusId, timesheetEnteredTypeId } = thunkApi.getState().timesheet;
                const response = await fetchAPI(`api/Timesheets/GetTimeEntryPeriodListByFilter/${timesheetPeriodListEmpId}/${timesheetFilterStartDate}/${timesheetFilterEndDate}/${includeDateRangePeriodList}/${timesheetApprovalStatusId}/${timesheetEnteredTypeId}`, 'GET', "", true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const addUpdateAccountEmployeeTimeEntryAsync = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/addUpdateAccountEmployeeTimeEntry',
        async (arg, thunkApi) => {
            try {
                const { decimalFormat, showClockStartEnd: timesheetShowClockStartEnd } = thunkApi.getState().timesheet;
                const { cultureInfoName, decimalPlaces, showClockStartEnd: globalStateShowClockStartEnd, showClockStartEndBy } = thunkApi.getState().globalState;

                let shouldShowClockStartEnd = false;

                if (showClockStartEndBy === "Account" && globalStateShowClockStartEnd === true) {
                    shouldShowClockStartEnd = true;
                } else if (showClockStartEndBy === "Employee" && timesheetShowClockStartEnd === true) {
                    shouldShowClockStartEnd = true;
                }
                const updatedArg = {
                    ...arg,
                    showClockStartEnd: shouldShowClockStartEnd,
                    SystemPlatformSourceId: "3D9FD131-9B80-43DA-AD66-CBE010F1B5A6"
                };
                const response = await <any>fetchAPI('api/Timesheets/AddAccountEmployeeTimeEntry', 'POST', updatedArg, true);
                if (response.status == 403) {
                    const json = await response.json();
                    return thunkApi.rejectWithValue(({ ...json[0], oldAccountEmployeeTimeEntryId: updatedArg.AccountEmployeeTimeEntryId, RowId: updatedArg.RowId, DetailRowId: updatedArg.DetailRowId, cultureInfoName, decimalPlaces }))
                }
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return { ...json, oldAccountEmployeeTimeEntryId: updatedArg.AccountEmployeeTimeEntryId, RowId: updatedArg.RowId, DetailRowId: updatedArg.DetailRowId, decimalFormat, cultureInfoName, decimalPlaces };
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const addCopyAccountEmployeeTimeEntryAsync = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/addCopyAccountEmployeeTimeEntryAsync',
        async (arg, thunkApi) => {
            try {

                const { decimalFormat, accountEmployeeTimeEntryPeriodId, showClockStartEnd: timesheetShowClockStartEnd } = thunkApi.getState().timesheet;
                const { showClockStartEnd: globalStateShowClockStartEnd, showClockStartEndBy } = thunkApi.getState().globalState;
                let showClockStartEnd: any = false;
                if (showClockStartEndBy === "Account" && globalStateShowClockStartEnd === true) {
                    showClockStartEnd = true;
                } else if (showClockStartEndBy === "Employee" && timesheetShowClockStartEnd === true) {
                    showClockStartEnd = true;
                }
                const response = await <any>fetchAPI(`api/Timesheets/AddCopyAccountEmployeeTimeEntry/${accountEmployeeTimeEntryPeriodId}/${showClockStartEnd}`, 'POST', arg, true);
                if (response.status == 403) {
                    const json = await response.json();
                    return thunkApi.rejectWithValue(({ ...json[0], oldAccountEmployeeTimeEntryId: arg.AccountEmployeeTimeEntryId, RowId: arg.RowId, DetailRowId: arg.DetailRowId }))
                }
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return { ...json, oldAccountEmployeeTimeEntryId: json.AccountEmployeeTimeEntryPeriodId, RowId: arg[0].RowId, DetailRowId: arg[0].DetailRowId, decimalFormat };
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const addImportedAccountEmployeeTimeEntryAsync = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/addImportedAccountEmployeeTimeEntryAsync',
        async (arg, thunkApi) => {
            try {
                const { decimalFormat } = thunkApi.getState().timesheet;
                const response = await <any>fetchAPI(`api/Timesheets/AddImportedAccountEmployeeTimeEntry`, 'POST', arg, true);
                if (response.status == 403) {
                    const json = await response.json();
                    return thunkApi.rejectWithValue(({ ...json[0], oldAccountEmployeeTimeEntryId: arg.AccountEmployeeTimeEntryId, RowId: arg.RowId, DetailRowId: arg.DetailRowId }))
                }
                if (response.status == 200) {
                    //return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return { ...json, oldAccountEmployeeTimeEntryId: arg.AccountEmployeeTimeEntryId, RowId: arg.RowId, DetailRowId: arg.DetailRowId, decimalFormat };
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const addAccountEmployeeTimeEntryTimerAsync = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/addAccountEmployeeTimeEntryTimerAsync',
        async (arg, thunkApi) => {
            try {
                let isIdExist = arg.AccountEmployeeTimeEntryId == null ? true : false
                const response = await <any>fetchAPI(`api/Timesheets/Timer?IsTimeEntryAutoSave=${isIdExist}`, 'POST', arg, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json;
                return
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const stopAccountEmployeeTimeEntryTimerAsync = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/stopAccountEmployeeTimeEntryTimerAsync',
        async (arg, thunkApi) => {
            try {
                const { lastEntryTimerId, accountEmployeeTimeEntryPeriodId } = thunkApi.getState().timesheet;
                const stopPayload = {
                    TimeEntryTimerStatus: 5,
                    AccountEmployeeTimeEntryPeriodId: accountEmployeeTimeEntryPeriodId || null,
                    Description: '',
                    SystemPlatformSourceId: "3D9FD131-9B80-43DA-AD66-CBE010F1B5A6"
                };
            //const response = await <any>fetchAPI(`api/Timesheets/ReactTimer/${lastEntryTimerId}?IsFromReact=true&totalSeconds=${Number(arg)}`, 'POST', { TimeEntryTimerStatus: 5, TimeEntryTimer: { AccountEmployeeTimeEntryPeriodId: accountEmployeeTimeEntryPeriodId, Description: null} }, true);
              const response = await <any>fetchAPI(`api/Timesheets/ReactTimer/${lastEntryTimerId}?IsFromReact=true&totalSeconds=${Number(arg)}`, 'POST', stopPayload, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const deleteAccountEmployeeTimeEntryTimerAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "timesheet/deleteAccountEmployeeTimeEntryTimerAsync",
        async (arg, thunkApi) => {
            const { lastEntryTimerId } = thunkApi.getState().timesheet;
            const { sessionAccountId, sessionAccountEmployeeId } = thunkApi.getState().globalState;
            const response = await fetchAPI(`api/Timesheets/ReactTimerDelete/${sessionAccountId}/${sessionAccountEmployeeId}/${lastEntryTimerId}`, 'Delete', arg, true);
            const json = await response.json();
            return json;
        }
    )

export const updateTimeEntriesAsync = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/updateTimeEntries',
        async (arg, thunkApi) => {
            try {
                const { RowId, IsTimeOff, ...argWithoutRowId } = arg;
                // const response = await <any>fetchAPI('api/Timesheets/UpdateTimeEntries', 'POST', argWithoutRowId, true);
                const response = await <any>fetchAPI('api/Timesheets/UpdateTimeEntriesForReact', 'POST', argWithoutRowId, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return { ...json, RowId: arg.RowId };
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const updateTimesheetPeriodAsync = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/updateTimesheetPeriod',
        async (arg, thunkApi) => {
            try {
                const { accountEmployeeTimeEntryPeriodId } = thunkApi.getState().timesheet;
                const response = await <any>fetchAPI(`api/Timesheets/UpdateTimesheetPeriod/${accountEmployeeTimeEntryPeriodId}`, 'POST', arg, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const submittedTimesheetAsync = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/submittedTimesheet',
        async (arg, thunkApi) => {
            try {
                const { lockSubmittedRecords, lockApprovedRecords } = thunkApi.getState().globalState;
                const response = await <any>fetchAPI(`api/Timesheets/v2/SubmitTimesheet`, 'POST', arg, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                //return json;
                return { result: json, lockSubmittedRecords: lockSubmittedRecords, lockApprovedRecords: lockApprovedRecords };
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const ApproveTimesheetForMobileAsync = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/ApproveTimesheetForMobile',
        async (arg, thunkApi) => {
            try {
                const response = await <any>fetchAPI(`api/V2/Timesheets/ApproveTimesheetForMobile`, 'POST', arg, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const SingleApproveTimesheetForMobileAsync = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/SingleApproveTimesheetForMobile',
        async (arg, thunkApi) => {
            try {
                const response = await <any>fetchAPI(`api/V2/Timesheets/SingleApproveTimesheetForMobile`, 'POST', arg, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const SingleApproveOrRejectAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Timesheets/v2/SingleApproveOrReject",
        async (arg, thunkApi) => {
            const { List, id, IncludeDateRange, ExpenseEntryStartDate, ExpenseEntryEndDate } = arg;
            let updatedList: any = [];
            if (id === "Approved") {
                updatedList = List.map((item: any) => {
                    return {
                        ...item, Approved: true
                    };
                });
            }
            else {
                updatedList = List.map((item: any) => {
                    return {
                        ...item, Approved: false
                    };
                });
            }
            const response = await fetchAPI("api/v2/Timesheets/SingleApproveTimesheetForMobile", "POST", updatedList, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const RejectTimesheetForMobileAsync = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/RejectTimesheetForMobile',
        async (arg, thunkApi) => {
            try {
                const response = await <any>fetchAPI(`api/V2/Timesheets/RejectTimesheetForMobile`, 'POST', arg, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const UpdateTimesheetPeriodListForPeriodStatusAsync = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/UpdateTimesheetPeriodListForPeriodStatus',
        async (arg, thunkApi) => {
            try {
                const response = await <any>fetchAPI(`api/Timesheets/UpdateTimesheetPeriodListForPeriodStatus/${arg.status}/${true}`, 'POST', arg.data.toString(), true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return { json: json, status: arg.status };
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const SingleApprovedTimesheetTimeOffForMobileAsync = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/ApprovedTimesheetTimeOffForMobile',
        async (arg, thunkApi) => {
            try {
                const response = await <any>fetchAPI(`api/V2/Timesheets/SingleApprovedTimesheetTimeOffForMobile`, 'POST', arg, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const SingleRejectTimesheetTimeOffForMobileAsync = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/RejectTimesheetTimeOffForMobile',
        async (arg, thunkApi) => {
            try {
                const response = await <any>fetchAPI(`api/V2/Timesheets/SingleRejectTimesheetTimeOffForMobile`, 'POST', arg, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const ApprovedSelectedTimesheetTimeOffForMobileAsync = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/ApprovedSelectedTimesheetTimeOffForMobile',
        async (arg, thunkApi) => {
            try {
                const response = await <any>fetchAPI(`api/V2/Timesheets/ApprovedSelectedTimesheetTimeOffForMobile`, 'POST', arg, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const RejectSelectedTimesheetTimeOffForMobileAsync = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/RejectSelectedTimesheetTimeOffForMobile',
        async (arg, thunkApi) => {
            try {
                const response = await <any>fetchAPI(`api/V2/Timesheets/RejectSelectedTimesheetTimeOffForMobile`, 'POST', arg, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

// Xero work commet
// export const SendToXero = createAsyncThunk
//     <any, any, IThunkApi>
//     (
//         'Integrations/SendToXero',
//         async (arg, thunkApi) => {
//             const { commaSeparatedIds, xeroAccessToken, xeroTenantId, exportType } = arg;
//             const requestBody = [{
//                 commaSeparatedIds: commaSeparatedIds,
//                 xeroAccessToken: xeroAccessToken,
//                 xeroTenantId: xeroTenantId
//             }];
//             const response = await fetchAPI(`api/V2/Integrations/SendToXero/${exportType}`, 'POST', requestBody, true);
//             const json = await response.json();
//             return json;
//         }
//     )

export const SendToXero = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Integrations/SendToXero',
        async (arg, thunkApi) => {
            const { commaSeparatedIds, exportType } = arg;
            const { sessionAccountId } = thunkApi.getState().globalState;
            const requestBody = [{ commaSeparatedIds: commaSeparatedIds, AccountId: sessionAccountId }];
            const response = await fetchAPI(`api/V2/Integrations/SendToXero/${exportType}`, 'POST', requestBody, true);
            const json = await response.json();
            return json;
        }
    )

export const getTimesheetTemplateAsync = createAsyncThunk
    <
        any,
        void,
        IThunkApi
    >
    (
        'timesheet/getTimesheetTemplateAsync',
        async (arg, thunkApi) => {
            try {
                const { accountEmployeeId } = thunkApi.getState().timesheet;
                const { sessionAccountId } = thunkApi.getState().globalState;
                const response = await fetchAPI(`api/v2/TimesheetTemplate/GetTimesheetTemplateForCopyTimesheet/${sessionAccountId}/${accountEmployeeId}`, 'GET', "", true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const getTimesheetPriod = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/getTimesheetPriod',
        async (arg, thunkApi) => {
            try {
                const { EmployeeId, StartDate, EndDate} = arg;
                const response = await fetchAPI(`api/Timesheets/GetTimeEntryPeriodListByFilter/${EmployeeId}/${StartDate}/${EndDate}/${true}/${0}/${2}`, 'GET', "", true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const getTimesheetApprovalsFilters = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'timesheet/getTimesheetApprovalsFilters',
        async (arg, thunkApi) => {
            try {
                const {sesssionEmployeeId,startDate, endDate, includeDateRange,projectvalue,employeeValues } = arg
                const response = await fetchAPI(`api/v2/Timesheets/GetTimesheetApprovalsWithFilters/${sesssionEmployeeId}/${0}/${startDate}/${endDate}/${includeDateRange}/${projectvalue}?EmployeeValues=${employeeValues}`, 'GET', "", true);
                // const response = await fetchAPI(`api/v2/Timesheets/GetTimesheetApprovalsWithFilters/${sesssionEmployeeId}/${0}/${startDate}/${endDate}/${includeDateRange}/${0}?EmployeeValues=${employeeValues}`, 'GET', "", true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const timesheetSlice = createSlice({
    name: 'timesheet',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.timeSheetPeriodIds = [];
            state.isAllChecked = false;
        },
        updateValuesFromGlobalState: (state, action: PayloadAction<any>) => {
            state.accountEmployeeId = action.payload;
            state.timesheetPeriodListEmpId = action.payload;
            state.timesheetPeriodApprovalListEmpId = action.payload;
        },
        updateSearchPagination: (state, action: PayloadAction<any>) => {
            state.isSearch = state.isSearch ? false : true;
            state.search = action.payload;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageNo = action.payload.pageNumber;
            state.startRec = action.payload.start;
            state.search = action.payload.search;
        },
        updateCurrentDate: (state, action: PayloadAction<any>) => {
            state.currentDate = action.payload.date;
            state.todayHours = "";
            state.totalHours = "";
            state.billableHours = "";
            state.nonBillableHours = "";
            state.isCopyTimesheet = false;
            state.isCopyActivities = false;
            state.isLoading = true;
            state.dateRangeMode = action.payload.mode;
            state.timeEntryPeriodIdForApproval = ''
        },
        updateAccountEmployeeId: (state, action: PayloadAction<number>) => {
            state.accountEmployeeId = action.payload;
            state.todayHours = "";
            state.totalHours = "";
            state.billableHours = "";
            state.nonBillableHours = "";
            state.isLoading = true;
        },
        updateMasterFieldsByRowId: (state, action: PayloadAction<any>) => {
            const index = state.timeEntriesList.findIndex((record) => record.rowId === action.payload.RowId);
            const newArray = [...state.timeEntriesList];
            newArray[index] = { ...newArray[index], ...action.payload }
            state.timeEntriesList = newArray;
        },
        updateDetailFieldsByDetailRowId: (state, action: PayloadAction<any>) => {
            //state.isLoading = true;
            const { RowId, DetailRowId } = action.payload;
            const masterRowIndex = state.timeEntriesList.findIndex((record) => record.rowId === RowId);
            const newArray = [...state.timeEntriesList[masterRowIndex].timeEntries];
            for (let key in newArray[DetailRowId]) {
                if (action.payload.hasOwnProperty(key)) {
                    newArray[DetailRowId][key] = action.payload[key];
                }
            }
            state.timeEntriesList[masterRowIndex].timeEntries = newArray;
            //state.isCopyActivities = false;
        },
        removeTimeEntryRow: (state, action: PayloadAction<any>) => {
            const newArr = state.timeEntriesList.filter(x => x.rowId !== Number(action.payload));
            state.timeEntriesList = newArr;
        },
        addBlankTimeEntryRow: (state) => {
            let newArr = [...state.timeEntriesList];
            let rowId = newArr.length;
            let newRowId = 1
            if (rowId > 0) {
                newRowId = Math.max(...newArr.map(member => member.rowId)) + 1;
            }
            newArr[rowId] = { ...newArr[0], rowId: newRowId };
            newArr[rowId].timeEntries = newArr[rowId].timeEntries.map((x: any) => {
                return { ...x, rowId: newRowId };
            });
            state.timeEntriesList = newArr;
        },
        addBlankTimeOffRow: (state) => {
            let newArr = [...state.timeEntriesList];
            let rowId = newArr.length;
            let newRowId = 1
            if (rowId > 0) {
                newRowId = Math.max(...newArr.map(member => member.rowId)) + 1;
            }
            newArr[rowId] = { ...newArr[0], rowId: newRowId };
            newArr[rowId].timeEntries = newArr[rowId].timeEntries.map((x: any) => {
                return { ...x, rowId: newRowId };
            });
            newArr[rowId].isTimeOff = true;
            state.timeEntriesList = newArr;
        },
        updateIsReload: (state, action: PayloadAction<boolean>) => {
            state.isReload = action.payload;
            state.isLoading = true;
        },
        updateIsStateHour: (state, action: PayloadAction<boolean>) => {
            state.isStateHour = action.payload;
        },
        updateIsStateMinute: (state, action: PayloadAction<boolean>) => {
            state.isStateMinute = action.payload;
        },
        updateIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
            state.isLoadingApproval = action.payload;
        },
        updateIsCanvasLoading: (state, action: PayloadAction<boolean>) => {
            state.isCanvasLoading = action.payload;
        },
        updateAllSelectedAndUnSelected: (state, action: PayloadAction<any>) => {
            state.timesheetApprovalList = action.payload;
        },
        updateSelectedResource: (state, action: PayloadAction<any>) => {
            const index = state.timesheetApprovalList.findIndex((item) => item.AccountEmployeeTimeEntryPeriodId === action.payload.AccountEmployeeTimeEntryPeriodId);
            if (action.payload.AccountEmployeeTimeEntryPeriodId === "") {
                const newRecordsArray = [...state.newRecords];
                newRecordsArray[index] = { ...newRecordsArray[index], AccountEmployeeId: action.payload.AccountEmployeeId };
                state.newRecords = newRecordsArray;
            }
            const newArray = [...state.timesheetApprovalList];
            newArray[index] = { ...newArray[index], IncludeTeam: 1, Status: action.payload.Status };
            state.timesheetApprovalList = newArray;
            //remove record array
            if (action.payload.AccountEmployeeTimeEntryPeriodId !== "") {
                const removeRecordsArray = [...state.removeRecords];
                removeRecordsArray[index] = { ...removeRecordsArray[index], AccountEmployeeTimeEntryPeriodId: 0 };
                state.removeRecords = removeRecordsArray;
            }
        },
        updateUnSelectedResource: (state, action: PayloadAction<any>) => {
            const index = state.timesheetApprovalList.findIndex((item) => item.AccountEmployeeTimeEntryPeriodId === action.payload.AccountEmployeeTimeEntryPeriodId);
            //remove row in array
            if (action.payload.AccountEmployeeTimeEntryPeriodId === "") {
                const newRecordsArray = [...state.newRecords];
                newRecordsArray[index] = { ...newRecordsArray[index], AccountEmployeeId: 0 };
                state.newRecords = newRecordsArray;
            }
            const newArray = [...state.timesheetApprovalList];
            newArray[index] = { ...newArray[index], IncludeTeam: 0, Status: action.payload.Status };
            state.timesheetApprovalList = newArray;
            //remove record
            if (action.payload.AccountEmployeeTimeEntryPeriodId !== "") {
                const removeRecordsArray = [...state.removeRecords];
                removeRecordsArray[index] = { ...removeRecordsArray[index], AccountEmployeeTimeEntryPeriodId: action.payload.AccountEmployeeTimeEntryPeriodId };
                state.removeRecords = removeRecordsArray;
            }
        },
        updateDescription: (state, action: PayloadAction<{ Description: string; AccountEmployeeTimeEntryPeriodId: string }>) => {
            const { Description, AccountEmployeeTimeEntryPeriodId } = action.payload;
            state.timesheetApprovalList = state.timesheetApprovalList.map((item) =>
                item.AccountEmployeeTimeEntryPeriodId === AccountEmployeeTimeEntryPeriodId
                    ? { ...item, Description: Description }
                    : item
            );
        },
        updateInValidTimeError: (state, action: PayloadAction<any>) => {
            const { rowId, detailRowId, message, hours } = action.payload as any;
            const currentRow = state.timeEntriesList.find(x => x.rowId === rowId);
            currentRow.timeEntries[detailRowId].ErrorMessage = message;
            currentRow.timeEntries[detailRowId].Hours = hours;
            currentRow.timeEntries[detailRowId].status = getTimeEntryStatus(false, false, true);
        },
        updateValidTimeError: (state, action: PayloadAction<any>) => {
            const { rowId, detailRowId, message, hours } = action.payload as any;
            const currentRow = state.timeEntriesList.find(x => x.rowId === rowId);
            currentRow.timeEntries[detailRowId].ErrorMessage = message;
            currentRow.timeEntries[detailRowId].Hours = hours;
            currentRow.timeEntries[detailRowId].status = getTimeEntryStatus(false, false, false);
        },
        updateCopyTimesheetState: (state, action: PayloadAction<any>) => {
            state.isLoading = true;
            state.isCopyTimesheet = action.payload.isCopyTimesheet;
            state.isCopyActivities = action.payload.isCopyActivities;
            state.isCopyTimesheetDate = action.payload.copyTimesheetDate;
            state.oldTimeEntryViewType = state.timeEntryViewType;
            state.copyTimeEntryAutoSave = false;
            state.isReload = state.isReload ? false : true;
            let tempArray = <any>[];
            state.timeEntriesList[0].timeEntries.map((item: any) => {
                tempArray.push(item.TimeEntryDate);
            });
            state.tempCopyHeader = tempArray;
        },
        updateTimerTimesheet: (state, action: PayloadAction<any>) => {
            state.timerObject = action.payload.timerArray;
        },
        updateStopTimerTimesheet: (state) => {
            state.autoTimer = false;
            state.lastEntryTimerId = 0;
            state.hoursRedux = 0;
            state.minutesRedux = 0;
            state.secondsRedux = 0;
            state.timeEntryIdForTimer = 0;
            state.timerObject = [
                {
                    "hours": 0,
                    "minutes": 0,
                    "seconds": 0
                }
            ];
        },
        updateTimerTimesheetState: (state, action: PayloadAction<any>) => {
            state.timeEntriesList.map((item: any) => {
                if (item.rowId === action.payload[0].rowId) {
                    item.IsTimer = action.payload[0].isPlay
                }
            });
            action.payload[0].isPlay && (state.isTimer = true);
            if (!action.payload[0].isPlay) {
                state.isLoading = true;
                state.isReload = true;
            }
        },
        updateTimerFromNavbarState: (state) => {
            state.timeEntriesList.map((item: any) => {
                item.IsTimer = false
            });
        },
        updateTimesheetApprovalStatusId: (state, action: PayloadAction<number>) => {
            state.timesheetApprovalStatusId = action.payload;
        },
        updateTimesheetEnteredTypeId: (state, action: PayloadAction<number>) => {
            state.timesheetEnteredTypeId = action.payload;
        },
        updateIncludeDateRange: (state, action: PayloadAction<boolean>) => {
            state.includeDateRange = action.payload;
        },
        updateIncludePeriodListDateRange: (state, action: PayloadAction<boolean>) => {
            state.includeDateRangePeriodList = action.payload;
        },
        updateTimesheetPeriodListEmpId: (state, action: PayloadAction<string>) => {
            state.timesheetPeriodListEmpId = action.payload;
        },
        updateTimesheetFilterDates: (state, action: PayloadAction<any>) => {
            state.timesheetFilterStartDate = action.payload.startDate;
            state.timesheetFilterEndDate = action.payload.endDate;
        },
        updateTimesheetApprovalFilterDates: (state, action: PayloadAction<any>) => {
            // state.timesheetApprovalStartDate = action.payload.startDate;
            // state.timesheetApprovalEndDate = action.payload.endDate;
            state.timesheetApprovalStartDate = moment(action.payload.startDate).format("YYYY-MM-DD");
            state.timesheetApprovalEndDate = moment(action.payload.endDate).format("YYYY-MM-DD");
        },
        updateTimesheetPeriodSelection: (state, action: PayloadAction<any>) => {
            state.timeSheetPeriodList.map((item: any) => {
                if (item.AccountEmployeeTimeEntryPeriodId == action.payload.id) {
                    item.isSelected = action.payload.isSelected;
                }
            });
        },
        updateTimesheetScrollButton: (state, action) => {
            state.showScrollButtons = action.payload;
        },
        updateTimesheetPeriodBulkSelection: (state, action: PayloadAction<boolean>) => {
            state.timeSheetPeriodList.map((item: any) => {
                item.isSelected = action.payload;
            });
        },
        setApproved: (state, action) => {
            const { Approved, AccountEmployeeTimeEntryPeriodId } = action.payload;
            const currentindex = state.timesheetApprovalList.findIndex((item) => item.AccountEmployeeTimeEntryPeriodId == AccountEmployeeTimeEntryPeriodId);
            const newArray = [...state.timesheetApprovalList];
            if (Approved === true) {
                newArray[currentindex] = { ...newArray[currentindex], 'Approved': true, 'Rejected': false, 'approvedButtonClass': 'btn-light-success btn-sm', 'rejectedButtonClass': 'btn-light-danger btn-sm' };
            }
            else {
                newArray[currentindex] = { ...newArray[currentindex], 'Approved': false, 'Rejected': true, 'approvedButtonClass': 'btn-success btn-sm', 'rejectedButtonClass': 'btn-light-danger btn-sm' };
            }
            state.timesheetApprovalList = newArray;
        },
        setRejected: (state, action) => {
            const { Rejected, AccountEmployeeTimeEntryPeriodId } = action.payload;
            const currentindex = state.timesheetApprovalList.findIndex((item) => item.AccountEmployeeTimeEntryPeriodId == AccountEmployeeTimeEntryPeriodId);
            const newArray = [...state.timesheetApprovalList];
            const isRejected = state.timesheetApprovalList[currentindex].Rejected;
            if (Rejected === true) {
                newArray[currentindex] = { ...newArray[currentindex], 'Approved': false, 'Rejected': true, 'approvedButtonClass': 'btn-light-success btn-sm', 'rejectedButtonClass': 'btn-light-danger btn-sm' };
            }
            else {
                newArray[currentindex] = { ...newArray[currentindex], 'Approved': false, 'Rejected': true, 'approvedButtonClass': 'btn-success btn-sm', 'rejectedButtonClass': 'btn-light-danger btn-sm' };
            }
            state.timesheetApprovalList = newArray;
        },
        setApprovedTimeOff: (state, action) => {
            const { Approved, AccountEmployeeTimeEntryPeriodId } = action.payload;
            const currentindex = state.timeoffApprovalList.findIndex((item) => item.AccountEmployeeTimeEntryPeriodId == AccountEmployeeTimeEntryPeriodId);
            const newArray = [...state.timeoffApprovalList];
            const isApproved = state.timeoffApprovalList[currentindex].Approved;
            if (isApproved === true) {
                newArray[currentindex] = { ...newArray[currentindex], 'Approved': false, 'Rejected': false, 'approvedButtonClass': 'btn-light-success btn-sm', 'rejectedButtonClass': 'btn-light-danger btn-sm' };
                //state.isPopupOpen = false;
                //state.selectedId = "";
            }
            else {
                newArray[currentindex] = { ...newArray[currentindex], 'Approved': Approved, 'Rejected': false, 'approvedButtonClass': 'btn-success btn-sm', 'rejectedButtonClass': 'btn-light-danger btn-sm' };
                //state.isPopupOpen = true;
                //state.selectedId = AccountEmployeeTimeOffRequestId;
            }
            state.timeoffApprovalList = newArray;
        },
        checkedState: (state, action) => {
            const currentindex = action.payload;
            if (currentindex !== undefined && state.timesheetApprovalList[currentindex]) {
                state.timesheetApprovalList[currentindex] = {
                    ...state.timesheetApprovalList[currentindex], isSelected: 1, reject: false, approve: false, rejectedButtonClass: 'btn-light-danger btn-sm', approvedButtonClass: 'btn-light-success btn-sm'
                };
            }
        },

        unCheckedState: (state, action) => {
            const currentindex = action.payload;
            if (currentindex !== undefined && state.timesheetApprovalList[currentindex]) {
                state.timesheetApprovalList[currentindex] = {
                    ...state.timesheetApprovalList[currentindex], isSelected: 0, reject: false, approve: false, rejectedButtonClass: 'btn-light-danger btn-sm', approvedButtonClass: 'btn-light-success btn-sm'
                };
            }
        },
        checkedAllState: (state) => {
            const newArray = state.timesheetApprovalList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.timesheetApprovalList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.timesheetApprovalList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.timesheetApprovalList = newArray;
            //state.isAllUnChecked = true;
        },
        setDateRangeValue: (state, action) => {
            const { startDate, endDate } = action.payload;
            state.startDate = startDate;
            state.endDate = endDate;
        },
        filterTimeOffApproval: (state, action) => {
            const { AccountTimeOffTypeId, TimeOffAccountEmployeeId, IncludeDateRange, StartDate, EndDate, AccountEmployeeId } = action.payload;
            const newArray = [...state.timesheetApprovalList];
            newArray.forEach((item: any) => {
                if (
                    (TimeOffAccountEmployeeId != 0 ? (item.TimeOffAccountEmployeeId == TimeOffAccountEmployeeId) : true) &&
                    (AccountTimeOffTypeId != 0 ? (item.AccountTimeOffTypeId == AccountTimeOffTypeId) : true) && // Use single quotes around the GUID
                    (IncludeDateRange ? (moment(item.StartDate).format('MM-DD-YYYY') >= StartDate && moment(item.EndDate).format('MM-DD-YYYY') <= EndDate) : true) &&
                    item.AccountEmployeeId == AccountEmployeeId
                ) {
                    item.isFiltered = 1;
                }
                else {
                    item.isFiltered = 0;
                }
            });
            state.timesheetApprovalList = newArray;
        },
        setOptionApproverEmployeeValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionApproverEmployeeValue = value;
            state.optionApproverEmployeeText = label;
        },
        updateTimesheetApprovalListEmpId: (state, action: PayloadAction<string>) => {
            state.timesheetPeriodApprovalListEmpId = action.payload;
        },
        updateTimesheetApprovalListProjectId: (state, action: PayloadAction<string>) => {
            state.timesheetPeriodApprovalListProjectId = action.payload;
        },
        checkedStatetimeoff: (state, action) => {
            const currentindex = state.timeoffApprovalList.findIndex((item) => item.AccountEmployeeTimeEntryId == action.payload);
            const newArray = [...state.timeoffApprovalList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1, 'Rejected': false, 'Approved': false, 'rejectedButtonClass': 'btn-light-danger btn-sm', 'approvedButtonClass': 'btn-light-success btn-sm' };
            state.timeoffApprovalList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedStatetimeoff: (state, action) => {
            const currentindex = state.timeoffApprovalList.findIndex((item) => item.AccountEmployeeTimeEntryId == action.payload);
            const newArray = [...state.timeoffApprovalList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0, 'Rejected': false, 'Approved': false, 'rejectedButtonClass': 'btn-light-danger btn-sm', 'approvedButtonClass': 'btn-light-success btn-sm' };
            state.timeoffApprovalList = newArray;
        },
        checkedAllStatetimeoff: (state) => {
            const newArray = state.timeoffApprovalList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.timeoffApprovalList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllStatetimeoff: (state) => {
            const newArray = state.timeoffApprovalList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.timeoffApprovalList = newArray;
            //state.isAllUnChecked = true;
        },
        setComments: (state, action) => {
            const { Comments, AccountEmployeeTimeEntryPeriodId } = action.payload;
            const currentindex = state.timesheetApprovalList.findIndex((item) => item.AccountEmployeeTimeEntryPeriodId == AccountEmployeeTimeEntryPeriodId);
            const newArray = [...state.timesheetApprovalList];
            newArray[currentindex] = { ...newArray[currentindex], Comments: Comments };
            state.timesheetApprovalList = newArray;
        },
        setCommentsTimeOff: (state, action) => {
            const { Comments, AccountEmployeeTimeEntryId } = action.payload;
            const currentindex = state.timeoffApprovalList.findIndex((item) => item.AccountEmployeeTimeEntryId == AccountEmployeeTimeEntryId);
            const newArray = [...state.timeoffApprovalList];
            newArray[currentindex] = { ...newArray[currentindex], Comments: Comments };
            state.timeoffApprovalList = newArray;
        },
        updateApprovalAccountProjectId: (state, action: PayloadAction<any>) => {
            state.approvalAccountProjectId = action.payload;
        },
        updateAccountEmployeeIdFromApproval: (state, action: PayloadAction<number>) => {
            state.timeEntryAccountEmployeeIds = action.payload;
        },
        updateToReoladTimesheetApproval: (state, action) => {
            state.timesheetApprovalList = [];
            state.isReloadApproval = !state.isReloadApproval //? false : true;
            state.isLoadingApproval = true;
        },
        updateTabIndex: (state, action: PayloadAction<any>) => {
            state.fromTabIndex = action.payload;
        },
        updateTimeEntryPeriodIdForPrint: (state, action: PayloadAction<any>) => {
            const { timeEntryPeriodIdForPrint, isForTimesheet } = action.payload;
            state.timeEntryPeriodIdForPrint = timeEntryPeriodIdForPrint;
            state.isForTimesheet = isForTimesheet
        },
        updateTimesheetApprovalDataForPrint: (state, action: PayloadAction<any>) => {
            const { timeEntryPeriodIdForPrint, isForTimesheet, systemApproverTypeForPrint, startDateForPrint, endDateForPrint, rowAccountEmployeeIdForPrint, approvalEmployeeName } = action.payload;
            state.timeEntryPeriodIdForPrint = timeEntryPeriodIdForPrint;
            state.isForTimesheet = isForTimesheet;
            state.systemApproverTypeForPrint = systemApproverTypeForPrint;
            state.startDateForPrint = startDateForPrint;
            state.endDateForPrint = endDateForPrint;
            state.rowAccountEmployeeIdForPrint = rowAccountEmployeeIdForPrint;
            state.approvalEmployeeName = approvalEmployeeName;
        },
        updateTimesheetAttachment: (state, action: PayloadAction<boolean>) => {
            state.isAttachment = action.payload;
        },
        updateApprovalDetails: (state, action: PayloadAction<any>) => {
            const { timeEntryPeriodIdForApproval, isApprovalDetail } = action.payload;
            state.timeEntryPeriodIdForApproval = timeEntryPeriodIdForApproval;
            state.isApprovalDetail = isApprovalDetail;
        },
        updateRefreshPrint: (state, action) => {
            state.refreshPrint = action.payload;
        },
        updateTimesheetOff: (state, action) => {
            state.IsMyTimeOff = action.payload;
        },
        setTimeSheetPeriodIdsState: (state, action) => {
            const { AccountEmployeeTimeEntryPeriodId, isChecked } = action.payload;
            if (isChecked) {
                // Add the ID to the selectedIds array if it's not already present
                if (!state.timeSheetPeriodIds.includes(AccountEmployeeTimeEntryPeriodId)) {
                    state.timeSheetPeriodIds.push(AccountEmployeeTimeEntryPeriodId);
                }
            } else {
                // Remove the ID from the selectedIds array if it's present
                state.timeSheetPeriodIds = state.timeSheetPeriodIds.filter(Id => Id !== AccountEmployeeTimeEntryPeriodId);
            }
            // Check if all items are selected
            const totalItems = state.timeSheetPeriodList.length;
            const selectedItemCount = state.timeSheetPeriodIds.length;
            // Update 'isAllChecked' based on the selection
            state.isAllChecked = totalItems > 0 && selectedItemCount === totalItems;
        },
        setAllTimeSheetPeriodIdsState: (state, action) => {
            const isChecked = action.payload;
            if (isChecked) {
                // Add all IDs to selectedIds
                state.timeSheetPeriodIds = state.timeSheetPeriodList.map(item => item.AccountEmployeeTimeEntryPeriodId);
            } else {
                // Clear all selected IDs
                state.timeSheetPeriodIds = [];
            }
            state.isAllChecked = isChecked;
        },
        setSelectedEmployee: (state, action) => {
            const newState = [...state.Employeesdata];
            const { values } = action.payload;
            newState.forEach((item: any) => {
                item.isSelected = 0;
            });
            values.forEach((selectedValue: any) => {
                const selectedItem = newState.find(
                    (item: any) => item.value == selectedValue
                );
                if (selectedItem) {
                    selectedItem.isSelected = 1;
                }
            });
            state.Employeesdata = newState;
        },
        updateLockingDateArray: (state, action: PayloadAction<any>) => {
            state.lockingDateArray = action.payload;
        },
        UpdateRefreshApi:(state, action)=>{
            state.refreshApi = action.payload;
        },
       resetFiltersState: (state) => {
            state.timesheetApprovalStartDate = moment().startOf('year').format("YYYY-MM-DD");
            state.timesheetApprovalEndDate = moment().endOf('year').format("YYYY-MM-DD");
            state.approvalAccountProjectId = 0;
            state.timeEntryAccountEmployeeIds = [];
            state.includeDateRange = true;
        },
        resetTimerState: (state) => {
            state.timerObject = [
                    {
                        "hours": 0,
                        "minutes": 0,
                        "seconds": 0
                    }
                ];           
            state.lastEntryTimerId = 0;
        },
        setTimerPulsing: (state, action: PayloadAction<boolean>) => {
            state.isTimerPulsing = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEmployeeAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getEmployeeAsync.fulfilled, (state, action) => {
                state.status = 'idle';
                state.employeeList = action.payload;
            })
            .addCase(getEmployeeAsync.rejected, (state) => {
                state.status = 'failed'
                state.employeeList = [];
            })
            .addCase(getTimesheetApprovalsWithFilters.pending, (state) => {
                state.status = 'loading';
                state.isLoadingApproval = true;
                state.timesheetApprovalList = [];
            })
            .addCase(getTimesheetApprovalsWithFilters.fulfilled, (state, action) => {

                if (action.payload != undefined) {
                    state.timesheetApprovalList = JSON.parse(action.payload.data);
                    state.timesheetApprovalList.map((item: any) => {
                        item.isSelected = 0
                    });
                } else {
                    state.timesheetApprovalList = [];
                }
                if (JSON.parse(action.payload.Employeesdata).length === 0) {
                    state.Employeesdata = [];
                }
                else {
                    state.Employeesdata = JSON.parse(action.payload.Employeesdata);
                    state.Employeesdata.map((item: any) => {
                        item.value = item.TimeEntryAccountEmployeeId;
                        item.label = item.EmployeeName;
                        item.isSelected = 0;
                    });
                }
                state.isLoadingApproval = false;
                //state.isForTimesheet = false;
            })
            .addCase(getTimesheetApprovalsWithFilters.rejected, (state) => {
                state.status = 'failed';
                state.isLoadingApproval = false;
            })
            .addCase(getTimeOffApprovalsWithFilters.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getTimeOffApprovalsWithFilters.fulfilled, (state, action) => {
                state.timeoffApprovalList = JSON.parse(action.payload.data);
                state.timeoffApprovalList.map((item: any) => {
                    item.isSelected = 0
                });
                state.status = 'idle';
                state.isReloadApproval = false;
                state.isLoadingApproval = false;
            })
            .addCase(getTimeOffApprovalsWithFilters.rejected, (state) => {
                state.status = 'failed';
            })
            // .addCase(getEmployeeProfileSettingAsync.pending, (state) => {
            //     state.status = 'loading';
            // })
            // .addCase(getEmployeeProfileSettingAsync.fulfilled, (state, action) => {
            //     state.status = 'idle';
            //     /////
            //     //const { d } = action.payload;
            //     // const { AccountEmployeeId, CurrentDate, DecimalFormat, IsPercentageFormat, TimeEntryViewType, ShowDescription, AccountWorkingDayTypeId, NumberOfBlankRowsInTimesheet,
            //     // NumberOfBlankRowsInTimeoff, CurrentCultureDateFormat, CustomFieldsTemplate, TimeEntryFormat, ShowProjectForTimeOff, ShowClientInTimesheet, ShowWorkTypeInTimeSheet, 
            //     // ShowClockStartEnd, ShowCostCenterInTimeSheet, AccessToken } = JSON.parse(d);
            //     /////
            //     let finalObj;
            //     if (NODE_ENV === "production") {
            //         finalObj = action.payload.hasOwnProperty("d") ? JSON.parse(action.payload.d) : JSON.parse(action.payload);
            //         //finalObj = JSON.parse(action.payload);
            //         //finalObj = JSON.parse(d);
            //     } else {
            //         finalObj = action.payload;
            //     }
            //     const { AccountEmployeeId, CurrentDate, DecimalFormat, IsPercentageFormat, TimeEntryViewType, ShowDescription, AccountWorkingDayTypeId, NumberOfBlankRowsInTimesheet,
            //         NumberOfBlankRowsInTimeoff, CurrentCultureDateFormat, CustomFieldsTemplate, TimeEntryFormat, ShowProjectForTimeOff, ShowClientInTimesheet, ShowWorkTypeInTimeSheet,
            //         ShowClockStartEnd, ShowCostCenterInTimeSheet, AccessToken, EmployeeName, EmployeeInitials, AccountWorkTypeId, AccountRoleId, EnableTimerInTimesheet } = finalObj;
            //     if (state.accountEmployeeId == 0) {
            //         state.accountEmployeeId = AccountEmployeeId;
            //         state.timesheetPeriodListEmpId = AccountEmployeeId;
            //     }
            //     //state.currentDate = moment(CurrentDate).format("YYYY-MM-DD");
            //     // // state.decimalFormat = DecimalFormat;
            //     // // state.isPercentageFormat = IsPercentageFormat;
            //     // // state.timeEntryViewType = TimeEntryViewType;
            //     // // state.showDescription = ShowDescription;
            //     // //state.accountWorkingDayTypeId = AccountWorkingDayTypeId;
            //     // // state.numberOfBlankRowsInTimesheet = NumberOfBlankRowsInTimesheet;
            //     //state.numberOfBlankRowsInTimeoff = NumberOfBlankRowsInTimeoff;
            //     state.CurrentCultureDateFormat = CurrentCultureDateFormat;
            //     state.customFieldsTemplate = CustomFieldsTemplate;
            //     // // state.timeEntryFormat = TimeEntryFormat;
            //     // // state.ShowProjectForTimeOff = ShowProjectForTimeOff;
            //     // // state.showClient = ShowClientInTimesheet;
            //     // // state.showWorkType = ShowWorkTypeInTimeSheet;
            //     ////state.showClockStartEnd = ShowClockStartEnd;
            //     // // state.showCostCenter = ShowCostCenterInTimeSheet;
            //     state.accessToken = AccessToken;
            //     state.employeeName = EmployeeName;
            //     // state.shortName = EmployeeInitials;
            //     state.defaultWorkTypeId = AccountWorkTypeId;
            //     // state.accountRoleId = AccountRoleId;
            //     // // state.enableTimerInTimesheet = EnableTimerInTimesheet
            //     // }
            // })
            // .addCase(getEmployeeProfileSettingAsync.rejected, (state) => {
            //     state.status = 'failed'
            //     state.employeeList = [];
            // })
            // .addCase(getAccountFeatureAsync.pending, (state) => {
            //     state.status = 'loading';
            // })
            // .addCase(getAccountFeatureAsync.fulfilled, (state, action) => {
            //     let tempAccountFeature = <any>[];
            //     action.payload.AccountFeatures.map((item: any) => {
            //         let obj = {
            //             "Id": item.SystemFeatureId,
            //             "Name": getAccountFeature(item.SystemFeatureId)
            //         }
            //         tempAccountFeature.push(obj)
            //     })
            //     state.accountFeatureList = tempAccountFeature;
            //     state.masterAccountRoleId = action.payload.AccountRoles[0].MasterAccountRoleId
            // })
            // .addCase(getAccountFeatureAsync.rejected, (state) => {
            //     state.status = 'failed';
            // })
            .addCase(getTimer.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getTimer.fulfilled, (state, action) => {
                if (action.payload.length > 0) {
                    let totalSeconds = action.payload[0].TotalSeconds;
                    let hours = Math.floor(totalSeconds / 3600);
                    let minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);
                    let seconds = totalSeconds - (hours * 3600) - (minutes * 60);
                    state.hoursRedux = hours;
                    state.minutesRedux = minutes;
                    state.secondsRedux = seconds;
                    state.autoTimer = true;
                    state.timerWidgetData = action.payload;
                    state.timeEntryIdForTimer = action.payload[0].AccountEmployeeTimeEntryId == null ? 0 : action.payload[0].AccountEmployeeTimeEntryId;
                    state.lastEntryTimerId = action.payload[0].TimeEntryTimerId
                    state.timerObject = [
                        {
                            "hours": hours,
                            "minutes": minutes,
                            "seconds": seconds
                        }
                    ];
                } else {
                    state.hoursRedux = 0;
                    state.minutesRedux = 0;
                    state.secondsRedux = 0;
                    state.autoTimer = false;
                    state.lastEntryTimerId = 0;
                    state.timeEntryIdForTimer = 0;
                }
            })
            .addCase(getTimer.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(getTimesheetPeriodAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getTimesheetPeriodAsync.fulfilled, (state, action) => {
                state.status = 'idle';
                // const result = <any>action.payload;
                const result = <any>action.payload["AccountEmployeeTimeEntryPeriod"];
                const resultWorkingDays = <any>action.payload["AccountWorkingDays"][0];
                state.noOfWorkingDays = resultWorkingDays?.WorkingDayNo?.split(',')?.length;
                state.workingDayNo = resultWorkingDays?.WorkingDayNo || "";
                const resultAccountPreferences = <any>action.payload["AccountPreferences"][0];
                if (state.isCopyTimesheet == false) {
                    state.timesheetStatus = setTimesheetStatus(result.Approved, result.Rejected, result.Submitted);
                    state.accountEmployeeTimeEntryPeriodId = result.AccountEmployeeTimeEntryPeriodId;
                    state.timeEntryViewType = result.TimeEntryViewType;
                    state.submittedDate = result.SubmittedDate;
                    state.startDate = moment(result.TimeEntryStartDate.split('T')[0]).format("YYYY-MM-DD");
                    state.endDate = moment(result.TimeEntryEndDate.split('T')[0]).format("YYYY-MM-DD");
                    //This line work fine before SS lock work
                    //state.isLocked = ((result.LockApprovedRecords && Boolean(result.Approved)) || (result.LockSubmittedRecords && Boolean(result.Submitted)) ? true : false);
                    //This code SS lock work
                    if (result.Rejected === "1") {
                        state.isLocked = false;
                    } else {
                        if (result.IsLockedYNID === '2') {
                            state.isLocked = (
                                (result.LockApprovedRecords && result.Approved) ||
                                (result.LockSubmittedRecords && result.Submitted)
                            ) ? true : false;
                        } else {
                            // fallback: use first condition logic
                            state.isLocked = (
                                (result.LockApprovedRecords && Boolean(result.Approved)) ||
                                (result.LockSubmittedRecords && Boolean(result.Submitted))
                            ) ? true : false;
                        }
                    }
                    state.isLocked = result.IsLockedYNID === '2' ? ((result.LockApprovedRecords == true && Boolean(result.Approved) == true) || (result.LockSubmittedRecords == true && Boolean(result.Submitted) == true) ? true : false) : true;
                    state.periodDescription = result.PeriodDescription;
                    //New Validation work start here
                    if (resultAccountPreferences.ShowClockStartEndBy == "Account" && (resultAccountPreferences.ShowClockStartEnd === 'Yes' ? true : false)) {
                        state.showClockStartEnd = true;
                    } else if (resultAccountPreferences.ShowClockStartEndBy == "Employee" && resultWorkingDays.ShowClockStartEndEmployee) {
                        state.showClockStartEnd = true;
                    } else {
                        state.showClockStartEnd = false;
                    }
                    state.decimalFormat = getTimeEntryHoursFormat(resultAccountPreferences.TimeEntryHoursFormatId) == 'Time' ? false : true;
                    //Pending Lock work start
                    // if (resultWorkingDays.LockAllPreviousTimesheets && state.dateRangeMode === 'previous') {
                    //     if (state.currentDate == moment(new Date()).format("YYYY-MM-DD")) {
                    //         state.isLocked = false;
                    //     } else {
                    //         state.isLocked = true;
                    //     }
                    // }
                    //Pending Lock work end
                    state.showClient = resultAccountPreferences.ShowClientInTimesheet === 'Yes' ? true : false;
                    state.showTimeEntriesDescription = resultAccountPreferences.ShowDescriptionInWeekView === 'Yes' ? true : false;
                    state.showWorkType = resultAccountPreferences.ShowWorkTypeInTimeSheet === 'Yes' ? true : false;
                    state.showCostCenter = resultAccountPreferences.ShowCostCenterInTimeSheet === 'Yes' ? true : false;
                    state.showCopyTimesheet = resultAccountPreferences.ShowCopyTimesheetButton === 'Yes' ? true : false;
                    state.showCopyActivityTimesheet = resultAccountPreferences.ShowCopyActivitiesButtonInTimesheet === 'Yes' ? true : false;
                    state.enableOfflineTimesheet = resultAccountPreferences.EnableOfflineTimesheet === 'Yes' ? true : false;
                    state.enableTimerInTimesheet = resultAccountPreferences.EnableTimerInTimesheet === 'Yes' ? true : false;
                    state.numberOfBlankRowsInTimesheet = resultAccountPreferences.NumberOfBlankRowsInTimeEntry === null ? 2 : resultAccountPreferences.NumberOfBlankRowsInTimeEntry;
                    //state.numberOfBlankRowsInTimeoff = resultAccountPreferences.NumberOfBlankRowsInTimeOff;
                    state.numberOfBlankRowsInTimeOff = resultAccountPreferences.NumberOfBlankRowsInTimeOff;
                    state.timeEntryFormat = resultAccountPreferences.TimeEntryFormat;
                    state.timesheetSubmissionMessage = resultAccountPreferences.TimesheetSubmissionMessage;
                    state.isPercentageFormat = resultAccountPreferences.ShowPercentageInTimesheet === 'Yes' ? true : false;
                    state.ShowProjectForTimeOff = resultAccountPreferences.ShowProjectForTimeOff === 'Yes' ? true : false;
                    state.isAllowOverlappingTimeEntries = resultAccountPreferences.IsAllowOverlappingTimeEntries === 'Yes' ? true : false;
                    state.showTemplateInTimesheet = resultAccountPreferences.ShowTemplateInTimesheet === 'Yes' ? true : false;
                    state.allowZeroHoursInTimesheet = resultAccountPreferences.AllowZeroHoursInTimesheet === 'Yes' ? true : false;
                    state.lockPreviousNextMonthTimesheetOn = resultWorkingDays.LockPreviousNextMonthTimesheetOn;
                } else {
                    state.copyStartDate = moment(result.TimeEntryStartDate.split('T')[0]).format("YYYY-MM-DD");
                    state.copyEndDate = moment(result.TimeEntryEndDate.split('T')[0]).format("YYYY-MM-DD");
                    state.periodDescription = result.PeriodDescription;
                }
                state.isSubmitted = result.Submitted || result.Rejected || result.Approved;
                //state.billableHours = result.BillableHours;
                //state.nonBillableHours = result.NonBillableHours;
            })
            .addCase(getTimesheetPeriodAsync.rejected, (state) => {
                state.status = 'failed'
                state.accountEmployeeTimeEntryPeriodId = null;
            })
            .addCase(getTimeEntriesByPeriodIdAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getTimeEntriesByPeriodIdAsync.fulfilled, (state, action) => {
                state.timeEntriesList = [];
                state.status = 'idle';
                let timeEntryRows = [];
                const { cultureInfoName, isTimesheetPolicy, decimalFormat, res, numberOfBlankRowsInTimesheet, numberOfBlankRowsInTimeOff, showTimeOffInTimesheet, timesheetSort } = action.payload as any;
                const regex = new RegExp(/TimeEntry[0-9]*$/g);
                state.isHoliday = false;
                state.isShowAttachment = false;
                let counterForCopy = 0;
                let tempApprovalProjectId;
                for (var i = 0; i < res.length; i++) {
                    let obj = res[i];
                    if (obj.AccountEmployeeTimeEntryApprovalProjectId != null) {
                        tempApprovalProjectId = obj.AccountEmployeeTimeEntryApprovalProjectId
                    }
                    let timeEntryRow = {
                        rowId: i,
                        AccountClientId: obj.AccountClientId,
                        ClientName: obj.ClientName,
                        AccountProjectId: obj.AccountProjectId,
                        ProjectName: obj.ProjectName,
                        TaskName: obj.TaskName,
                        TaskCode: obj.TaskCode,
                        AdditionalTaskInfo: obj.AdditionalTaskInfo,
                        AdditionalProjectInfo: obj.AdditionalProjectInfo,
                        AccountProjectTaskId: obj.AccountProjectTaskId,
                        WorkType: obj.AccountWorkType,
                        AccountWorkTypeId: obj.AccountWorkTypeId,
                        CostCenter: obj.AccountCostCenter,
                        AccountCostCenterId: obj.AccountCostCenterId,
                        AccountEmployeeTimeEntryApprovalProjectId: (obj.AccountProjectTaskId != null && obj.AccountEmployeeTimeEntryApprovalProjectId != null) ? obj.AccountEmployeeTimeEntryApprovalProjectId : (obj.AccountProjectTaskId != null && obj.AccountEmployeeTimeEntryApprovalProjectId == null) ? tempApprovalProjectId : null,
                        Total: 0.00,
                        isTimeOff: ((obj.IsTimeOff == null || obj.IsTimeOff == '0') ? false : obj.IsTimeOff),
                        AccountTimeOffType: obj.AccountTimeOffType,
                        AccountTimeOffTypeId: obj.AccountTimeOffTypeId,
                        IsBillable: obj.IsBillable,
                        IsTimer: false,
                        AccountEmployeeTimeOffRequestId: obj.AccountEmployeeTimeOffRequestId,
                        Completed: obj.Completed,
                        timeEntries: [] as any
                    };
                    for (var key in obj) {
                        if (regex.test(key)) {
                            obj[key] = (obj[key] == null ? "" : obj[key]);
                            if (state.isCopyActivities == true) {
                                timeEntryRow.Total = 0;
                            } else {
                                timeEntryRow.Total += obj[key] ? obj[key] : 0;
                            }
                            // let timeEntryDetail = {
                            //     rowId: i,
                            //     AccountEmployeeTimeEntryId: obj[key + "_ID"],
                            //     Hours: (obj[key] == "" ? 0 : obj[key]),
                            //     HoursDisplayText: displayValueForTimeEntry(obj[key], isTimesheetPolicy, decimalFormat),
                            //     code: obj[key + "_CODE"],
                            //     status: getStatusByName(obj[key + "_STATUS"]),
                            //     isDayOff: (obj[key + "_DAYOFF"] == null ? 0 : obj[key + "_DAYOFF"]),
                            //     CustomField1: obj[key + "_CUSTOMFIELD1"],
                            //     CustomField2: obj[key + "_CUSTOMFIELD2"],
                            //     CustomField3: obj[key + "_CUSTOMFIELD3"],
                            //     CustomField4: obj[key + "_CUSTOMFIELD4"],
                            //     CustomField5: obj[key + "_CUSTOMFIELD5"],
                            //     CustomField6: obj[key + "_CUSTOMFIELD6"],
                            //     CustomField7: obj[key + "_CUSTOMFIELD7"],
                            //     CustomField8: obj[key + "_CUSTOMFIELD8"],
                            //     CustomField9: obj[key + "_CUSTOMFIELD9"],
                            //     // TimeEntryDate: moment(key.toString().replace('TimeEntry', '').replace('_DAYDAT', ''), '').format('YYYY-MM-DD'),
                            //     TimeEntryDate: state.isCopyTimesheet == false ? moment(key.toString().replace('TimeEntry', '').replace('_DAYDAT', ''), '').format('YYYY-MM-DD')
                            //         : moment(state.tempCopyHeader[counterForCopy]).format('YYYY-MM-DD'),
                            //     Description: obj[key + "_DESCRIPTION"],
                            //     Holiday: obj[key + "_HOLIDAY"],
                            //     holidayName: obj[key + "_HOLIDAYNAME"],
                            //     ErrorMessage: "",
                            //     StartTime: obj[key + "_STARTTIME"] != null ? moment(obj[key + "_STARTTIME"]).format('hh:mm') : '00:00',
                            //     EndTime: obj[key + "_ENDTIME"] != null ? moment(obj[key + "_ENDTIME"]).format('hh:mm') : '00:00'
                            // };
                            const setCustomFieldValues = (customField: string, customFieldData: any, customFields: any) => {
                                let foundItem = customFields.find((item: any) => item.DatabaseFieldName === customField);
                                if (!foundItem) return customFieldData;
                                if (foundItem.MasterCustomDataTypeName === 'Date') {
                                    return customFieldData;
                                }
                                else if (foundItem.MasterCustomDataTypeName === 'Number') {
                                    if (customFieldData !== null && customFieldData !== undefined && customFieldData !== '') {
                                        return formatNumberCustomoriginalapiv2(cultureInfoName.toString(), customFieldData, 2);
                                    }
                                    return customFieldData;
                                }
                                else {
                                    return customFieldData;
                                }
                            }
                            let timeEntryDetail = {
                                rowId: i,
                                AccountEmployeeTimeEntryId: obj[key + "_ID"],
                                Hours: (obj[key] == "" ? 0 : obj[key]),
                                HoursDisplayText: displayValueForTimeEntry(obj[key], isTimesheetPolicy, decimalFormat),
                                code: obj[key + "_CODE"],
                                status: getStatusByName(obj[key + "_STATUS"]),
                                isDayOff: (obj[key + "_DAYOFF"] == null ? 0 : obj[key + "_DAYOFF"]),
                                //CustomField1: obj[key + "_CUSTOMFIELD1"],
                                CustomField1: setCustomFieldValues('CustomField1', obj[key + "_CUSTOMFIELD1"], state.customFieldsTemplate),
                                //CustomField1: obj[key + "_CUSTOMFIELD1"],
                                CustomField2: setCustomFieldValues('CustomField2', obj[key + "_CUSTOMFIELD2"], state.customFieldsTemplate),
                                CustomField3: setCustomFieldValues('CustomField3', obj[key + "_CUSTOMFIELD3"], state.customFieldsTemplate),
                                CustomField4: setCustomFieldValues('CustomField4', obj[key + "_CUSTOMFIELD4"], state.customFieldsTemplate),
                                CustomField5: setCustomFieldValues('CustomField5', obj[key + "_CUSTOMFIELD5"], state.customFieldsTemplate),
                                CustomField6: setCustomFieldValues('CustomField6', obj[key + "_CUSTOMFIELD6"], state.customFieldsTemplate),
                                CustomField7: setCustomFieldValues('CustomField7', obj[key + "_CUSTOMFIELD7"], state.customFieldsTemplate),
                                CustomField8: setCustomFieldValues('CustomField8', obj[key + "_CUSTOMFIELD8"], state.customFieldsTemplate),
                                CustomField9: setCustomFieldValues('CustomField9', obj[key + "_CUSTOMFIELD9"], state.customFieldsTemplate),
                                TimeEntryDate: state.isCopyTimesheet == false ? moment(key.toString().replace('TimeEntry', '').replace('_DAYDAT', ''), '').format('YYYY-MM-DD')
                                    : moment(state.tempCopyHeader[counterForCopy]).format('YYYY-MM-DD'),
                                Description: obj[key + "_DESCRIPTION"],
                                Holiday: obj[key + "_HOLIDAY"],
                                holidayName: obj[key + "_HOLIDAYNAME"],
                                ErrorMessage: "",
                                // StartTime: obj[key + "_STARTTIME"] != null ? moment(obj[key + "_STARTTIME"]).format('hh:mm') : '00:00',
                                StartTime: obj[key + "_STARTTIME"] != null ? moment.parseZone(obj[key + "_STARTTIME"]).format('HH:mm') : '00:00',
                                // StartTime: obj[key + "_STARTTIME"] != null ? moment(obj[key + "_STARTTIME"].split('+')[0]).format('HH:mm') : '00:00',
                                // EndTime: obj[key + "_ENDTIME"] != null ? moment(obj[key + "_ENDTIME"]).format('hh:mm') : '00:00'
                                EndTime: obj[key + "_ENDTIME"] != null ? moment.parseZone(obj[key + "_ENDTIME"]).format('HH:mm') : '00:00',
                                // EndTime: obj[key + "_ENDTIME"] != null ? moment(obj[key + "_ENDTIME"].split('+')[0]).format('HH:mm') : '00:00'
                                isLockPreviousNextTimesheetsOn: state.lockingDateArray.length > 0 ? (state.lockingDateArray.filter(x => x === moment(key.toString().replace('TimeEntry', '').replace('_DAYDAT', ''), '').format('YYYY-MM-DD')).length > 0 ? false : true) : false
                            };
                            if (state.isCopyActivities == true) {
                                // timeEntryDetail.AccountEmployeeTimeEntryId = 0;
                                timeEntryDetail.AccountEmployeeTimeEntryId = null;
                                timeEntryDetail.status = 'no-record';
                                timeEntryDetail.Hours = 0;
                                timeEntryDetail.HoursDisplayText = displayValueForTimeEntry(0, isTimesheetPolicy, decimalFormat);
                                timeEntryDetail.CustomField1 = '';
                                timeEntryDetail.CustomField2 = '';
                                timeEntryDetail.CustomField3 = '';
                                timeEntryDetail.CustomField4 = '';
                                timeEntryDetail.CustomField5 = '';
                                timeEntryDetail.CustomField6 = '';
                                timeEntryDetail.CustomField7 = '';
                                timeEntryDetail.CustomField8 = '';
                                timeEntryDetail.CustomField9 = '';
                                timeEntryDetail.Description = '';
                                timeEntryDetail.StartTime = '00:00';
                                timeEntryDetail.EndTime = '00:00'
                            }
                            counterForCopy = counterForCopy + 1;
                            if (obj[key + "_HOLIDAY"] != null) {
                                state.isHoliday = true;
                            }
                            if (obj[key + "_ID"] != null && state.timeEntryIdForTimer > 0 && obj[key + "_ID"] == state.timeEntryIdForTimer) {
                                timeEntryRow.IsTimer = true;
                            }
                            if (obj[key + "_ID"] != null) {
                                state.isShowAttachment = true;
                            }
                            if (state.autoTimer === false) {
                                timeEntryRow.IsTimer = false;
                            }
                            // if(state.allowZeroHoursInTimesheet && timeEntryDetail.AccountEmployeeTimeEntryId === null){
                            //     timeEntryDetail.HoursDisplayText = "";
                            //     timeEntryDetail.Hours = "";
                            // }
                            timeEntryRow.timeEntries.push(timeEntryDetail);
                        }
                    }
                    timeEntryRows.push(timeEntryRow);
                }
                if (state.isCopyTimesheet) {
                    timeEntryRows.map((item) => {
                        item.timeEntries.map((item: any, index: number) => {
                            item.TimeEntryDate = moment(state.tempCopyHeader[index]).format('YYYY-MM-DD')
                        });
                    });
                }
                let newTimeEntryRows = [...timeEntryRows];
                for (var i = 0; i < numberOfBlankRowsInTimesheet; i++) {
                    let rowId = newTimeEntryRows.length;
                    newTimeEntryRows[rowId] = { ...newTimeEntryRows[0], rowId };
                    newTimeEntryRows[rowId].timeEntries = newTimeEntryRows[rowId]?.timeEntries?.map((x: any) => {
                        return { ...x, rowId: rowId };
                    });
                }
                // for (var i = 0; i < numberOfBlankRowsInTimeOff; i++) {
                //     let rowId = newTimeEntryRows.length;
                //     newTimeEntryRows[rowId] = { ...newTimeEntryRows[0], rowId };
                //     newTimeEntryRows[rowId].isTimeOff = true;
                //     newTimeEntryRows[rowId].timeEntries = newTimeEntryRows[rowId].timeEntries.map((x: any) => {
                //         return { ...x, rowId: rowId };
                //     });
                // }
                // let total = newTimeEntryRows.reduce(function (a, b) {
                //     return a + b.Total;
                // }, 0);
                // let tempToday = 0
                // let totalToday = newTimeEntryRows.reduce((a, b) => {
                //     if (b.AccountProjectTaskId != null) {
                //         b.timeEntries.map((item: any) => {
                //             if (item.AccountEmployeeTimeEntryId != null && (moment(new Date()).format("YYYY-MM-DD") == item.TimeEntryDate)) {
                //                 tempToday = tempToday + item.Hours;
                //             }
                //         })
                //     }
                //     return tempToday;
                // }, 0);
                // state.todayHours = displayValueForTimeEntry(totalToday, isTimesheetPolicy, decimalFormat).toString();
                // state.totalHours = displayValueForTimeEntry(total, isTimesheetPolicy, decimalFormat).toString();
                state.todayHours = "";
                state.totalHours = "";
                state.billableHours = "";
                state.nonBillableHours = "";
                let tempTodayHours = (state.isCopyTimesheet || state.isImportedTimesheet || state.isTimer) ? 0 : Number(state.todayHours);
                let tempTotalHours = (state.isCopyTimesheet || state.isImportedTimesheet || state.isTimer) ? 0 : Number(state.totalHours);
                let tempBillableHours = (state.isCopyTimesheet || state.isImportedTimesheet || state.isTimer) ? 0 : Number(state.billableHours);
                let tempNonBillableHours = (state.isCopyTimesheet || state.isImportedTimesheet || state.isTimer) ? 0 : Number(state.nonBillableHours);
                // billableHours
                if (state.isCopyActivities == false) {
                    newTimeEntryRows.map((item: any) => {
                        if (item.AccountProjectTaskId != null || Number(item.isTimeOff) == 1) {
                            item.timeEntries.map((x: any) => {
                                if (x.AccountEmployeeTimeEntryId != null) {
                                    if (moment(new Date()).format("YYYY-MM-DD") == x.TimeEntryDate && (item.isTimeOff === false || Number(item.isTimeOff) === 0)) {
                                        tempTodayHours = tempTodayHours + x.Hours;
                                    }
                                    if (item.isTimeOff === false || Number(item.isTimeOff) === 0) {
                                        tempTotalHours = Number(tempTotalHours) + Number(x.Hours);
                                    } else {
                                        if (showTimeOffInTimesheet) {
                                            tempTotalHours = Number(tempTotalHours) + Number(x.Hours);
                                        } else {
                                            tempTotalHours = Number(tempTotalHours) + 0;
                                        }
                                    }
                                    // tempTotalHours = Number(tempTotalHours) + Number(x.Hours);
                                }
                            });
                            if (item.AccountProjectTaskId != null) {
                                if (Number(item.IsBillable) === 1) {
                                    tempBillableHours = tempBillableHours + item.Total;
                                } else {
                                    tempNonBillableHours = tempNonBillableHours + item.Total;
                                }
                            }
                        }
                    });
                }
                state.todayHours = displayValueForTimeEntry(tempTodayHours, isTimesheetPolicy, decimalFormat).toString();
                state.totalHours = displayValueForTimeEntry(tempTotalHours, isTimesheetPolicy, decimalFormat).toString();
                state.billableHours = displayValueForTimeEntry(tempBillableHours, isTimesheetPolicy, decimalFormat).toString();
                state.nonBillableHours = displayValueForTimeEntry(tempNonBillableHours, isTimesheetPolicy, decimalFormat).toString();
                state.decimalTotalHours = tempTotalHours;
                if (timesheetSort !== "Default") {
                    if (timesheetSort === "Client") {
                        newTimeEntryRows.sort((a, b) => {
                            const nameA = a.ClientName != null ? a.ClientName.toLowerCase() : "";
                            const nameB = b.ClientName != null ? b.ClientName.toLowerCase() : "";
                            if (nameA != "" && nameB != "") { return nameA.localeCompare(nameB); }
                        });
                    } else if (timesheetSort === "Project" || timesheetSort === "ProjectTask") {
                        newTimeEntryRows.sort((a, b) => {
                            const nameA = a.ProjectName != null ? a.ProjectName.toLowerCase() : "";
                            const nameB = b.ProjectName != null ? b.ProjectName.toLowerCase() : "";
                            if (nameA != "" && nameB != "") { return nameA.localeCompare(nameB); }
                        });
                    } else if (timesheetSort === "Task") {
                        newTimeEntryRows.sort((a, b) => {
                            const nameA = a.TaskName != null ? a.TaskName.toLowerCase() : "";
                            const nameB = b.TaskName != null ? b.TaskName.toLowerCase() : "";
                            if (nameA != "" && nameB != "") { return nameA.localeCompare(nameB); }
                        });
                    }
                }
                // state.timeEntriesList = newTimeEntryRows;
                if (state.isCopyTimesheet) {
                    state.timeEntriesList = newTimeEntryRows.filter(x => x.Completed == null || x.Completed == '0');
                    state.isLoading = false;
                    state.copyTimeEntryAutoSave = true;
                    //state.isReload = false;
                } else {
                    state.timeEntriesList = newTimeEntryRows;
                    state.isLoading = false;
                    state.isReload = false;
                    state.isImportedTimesheet = false;
                }
            })
            .addCase(getTimeEntriesByPeriodIdAsync.rejected, (state) => {
                state.status = 'failed'
                state.isLoading = false;
                state.isReload = false;
            })
            .addCase(getCustomFieldTemplateAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getCustomFieldTemplateAsync.fulfilled, (state, action) => {
                state.status = 'idle';
                state.customFieldsTemplate = action.payload;
            })
            .addCase(getCustomFieldTemplateAsync.rejected, (state) => {
                state.status = 'failed'
                state.customFieldsTemplate = [];
            })
            .addCase(getTimeEntryPeriodListAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getTimeEntryPeriodListAsync.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
                action.payload.map((item: any) => {
                    item.isSelected = false;
                });
                state.timeSheetPeriodList = !("Message" in action.payload[0]) ? action.payload : [];
            })
            .addCase(getTimeEntryPeriodListAsync.rejected, (state) => {
                state.status = 'failed'
                state.timeSheetPeriodList = [];
                state.isLoading = false;
            })
            .addCase(addUpdateAccountEmployeeTimeEntryAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addUpdateAccountEmployeeTimeEntryAsync.fulfilled, (state, action) => {
                state.isStateHour = false
                state.isStateMinute = false
                state.isLoading = false;
                //state.isReload = false;
                state.status = 'idle';
                const { AccountEmployeeTimeEntryPeriodId, id, AccountEmployeeTimeEntryApprovalProjectId, Submitted, Approved, RowId, DetailRowId, decimalFormat, isTimesheetPolicy, cultureInfoName, decimalPlaces } = action.payload;
                state.accountEmployeeTimeEntryPeriodId = AccountEmployeeTimeEntryPeriodId
                const currentRow = state.timeEntriesList.find(x => x.rowId === RowId);
                const totalRowHours = currentRow.timeEntries.reduce(function (a: any, b: any) {
                    return a + b.Hours;
                }, 0);
                currentRow.Total = totalRowHours;
                let totalH = state.timeEntriesList.reduce(function (a, b) {
                    return a + b.Total;
                }, 0);
                let tempToday = 0
                let tempBillableHours = 0
                let tempNonBillableHours = 0
                let totalToday = state.timeEntriesList.reduce((a, b) => {
                    if (b.AccountProjectTaskId != null) {
                        b.timeEntries.map((item: any) => {
                            if (item.AccountEmployeeTimeEntryId != null && (moment(new Date()).format("YYYY-MM-DD") == item.TimeEntryDate)) {
                                tempToday = tempToday + item.Hours;
                            }
                            if (Number(b.IsBillable) === 1) {
                                tempBillableHours = tempBillableHours + item.Hours;
                            } else {
                                tempNonBillableHours = tempNonBillableHours + item.Hours;
                            }
                        })
                    }
                    return tempToday;
                }, 0);
                const detailRow = currentRow.timeEntries[DetailRowId];

                state.todayHours = displayValueForTimeEntry(totalToday, isTimesheetPolicy, decimalFormat).toString();
                state.totalHours = displayValueForTimeEntry(totalH, isTimesheetPolicy, decimalFormat).toString();
                state.billableHours = displayValueForTimeEntry(tempBillableHours, isTimesheetPolicy, decimalFormat).toString();
                state.nonBillableHours = displayValueForTimeEntry(tempNonBillableHours, isTimesheetPolicy, decimalFormat).toString();
                //state.billableHours = result.BillableHours;
                //state.nonBillableHours = result.NonBillableHours;
                currentRow.AccountEmployeeTimeEntryApprovalProjectId = AccountEmployeeTimeEntryApprovalProjectId;
                currentRow.timeEntries[DetailRowId].AccountEmployeeTimeEntryId = id;
                // currentRow.timeEntries[DetailRowId].status = getTimeEntryStatus(Submitted, Approved, false);
                currentRow.timeEntries[DetailRowId].status = getTimeEntryStatus(Approved, Submitted, false);
                currentRow.timeEntries[DetailRowId].ErrorMessage = "";
                state.decimalTotalHours = state.decimalTotalHours + currentRow.Total;
                state.isShowAttachment = true;

                state.customFieldsTemplate.forEach(cf => {
                    const fieldName = cf.DatabaseFieldName;
                    const fieldValue = detailRow[fieldName];

                    if (cf.MasterCustomDataTypeName === "Number") {
                        try {
                            let num = Number(fieldValue);

                            if (!isNaN(num)) {
                                detailRow[fieldName] = formatNumberCustomoriginalapiv2(cultureInfoName.toString(), num.toString(), decimalPlaces);
                            }
                        } catch (error) {
                            console.error(`Error formatting ${fieldName}:`, error);
                        }
                    }

                });
            })
            .addCase(addUpdateAccountEmployeeTimeEntryAsync.rejected, (state, action) => {
                state.isLoading = false;
                state.isReload = false;
                state.status = 'failed'
                const { RowId, DetailRowId, ErrorMessage, cultureInfoName, decimalPlaces } = action.payload as any;
                const currentRow = state.timeEntriesList.find(x => x.rowId === RowId);
                currentRow.timeEntries[DetailRowId].ErrorMessage = ErrorMessage;
                currentRow.timeEntries[DetailRowId].status = getTimeEntryStatus(false, false, true);
                const detailRow = currentRow.timeEntries[DetailRowId];
                state.customFieldsTemplate.forEach(cf => {
                    const fieldName = cf.DatabaseFieldName;
                    const fieldValue = detailRow[fieldName];
                    if (cf.MasterCustomDataTypeName === "Number") {
                        try {
                            let num = Number(fieldValue);
                            if (!isNaN(num)) {
                                detailRow[fieldName] = formatNumberCustomoriginalapiv2(cultureInfoName.toString(), num.toString(), decimalPlaces);
                            }
                        } catch (error) {
                            console.error(`Error formatting ${fieldName}:`, error);
                        }
                    }
                });
            })
            .addCase(addCopyAccountEmployeeTimeEntryAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addCopyAccountEmployeeTimeEntryAsync.fulfilled, (state, action) => {
                if (state.isCopyActivities) {
                    state.isCopyActivities = false;
                    state.isCopyTimesheet = false;
                    state.isLoading = false;
                    //state.isReload = false;
                    //state.status = 'idle';
                    const { AccountEmployeeTimeEntryPeriodId, id, AccountEmployeeTimeEntryApprovalProjectId, Submitted, Approved, RowId, DetailRowId, decimalFormat, isTimesheetPolicy } = action.payload;
                    state.accountEmployeeTimeEntryPeriodId = AccountEmployeeTimeEntryPeriodId
                    const currentRow = state.timeEntriesList.find(x => x.rowId === RowId);
                    const totalRowHours = currentRow.timeEntries.reduce(function (a: any, b: any) {
                        return a + b.Hours;
                    }, 0);
                    currentRow.Total = totalRowHours;
                    let totalH = state.timeEntriesList.reduce(function (a, b) {
                        return a + b.Total;
                    }, 0);
                    let tempToday = 0
                    let tempBillableHours = 0
                    let tempNonBillableHours = 0
                    let totalToday = state.timeEntriesList.reduce((a, b) => {
                        if (b.AccountProjectTaskId != null) {
                            b.timeEntries.map((item: any) => {
                                if (item.AccountEmployeeTimeEntryId != null && (moment(new Date()).format("YYYY-MM-DD") == item.TimeEntryDate)) {
                                    tempToday = tempToday + item.Hours;
                                }
                                if (Number(b.IsBillable) === 1) {
                                    tempBillableHours = tempBillableHours + item.Hours;
                                } else {
                                    tempNonBillableHours = tempNonBillableHours + item.Hours;
                                }
                            })
                        }
                        return tempToday;
                    }, 0);
                    state.todayHours = displayValueForTimeEntry(totalToday, isTimesheetPolicy, decimalFormat).toString();
                    state.totalHours = displayValueForTimeEntry(totalH, isTimesheetPolicy, decimalFormat).toString();
                    state.billableHours = displayValueForTimeEntry(tempBillableHours, isTimesheetPolicy, decimalFormat).toString();
                    state.nonBillableHours = displayValueForTimeEntry(tempNonBillableHours, isTimesheetPolicy, decimalFormat).toString();
                    currentRow.AccountEmployeeTimeEntryApprovalProjectId = AccountEmployeeTimeEntryApprovalProjectId;
                    currentRow.timeEntries[DetailRowId].AccountEmployeeTimeEntryId = id;
                    currentRow.timeEntries[DetailRowId].status = getTimeEntryStatus(Approved, Submitted, false);
                    currentRow.timeEntries[DetailRowId].ErrorMessage = "";
                    state.decimalTotalHours = state.decimalTotalHours + currentRow.Total;
                    state.isShowAttachment = true;
                }

                else {
                    state.isReload = true;
                    state.isCopyActivities = false;
                    state.isCopyTimesheet = false;
                    state.isLoading = false;
                    state.status = 'idle';
                }
            })

            .addCase(addCopyAccountEmployeeTimeEntryAsync.rejected, (state) => {
                state.isLoading = false;
                state.isReload = false;
                state.status = 'failed';
            })
            .addCase(addImportedAccountEmployeeTimeEntryAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addImportedAccountEmployeeTimeEntryAsync.fulfilled, (state, action) => {
                state.isImportedTimesheet = true;
                state.status = 'idle';
            })
            .addCase(addImportedAccountEmployeeTimeEntryAsync.rejected, (state) => {
                state.isLoading = false;
                state.isReload = false;
                state.isImportedTimesheet = false;
                state.status = 'failed';
            })
            .addCase(addAccountEmployeeTimeEntryTimerAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addAccountEmployeeTimeEntryTimerAsync.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isReload = false;
                state.status = 'idle';
                state.lastEntryTimerId = action.payload.id;
                state.isTimerCloseWithNoEntry = false;
            })
            .addCase(addAccountEmployeeTimeEntryTimerAsync.rejected, (state) => {
                state.isLoading = false;
                state.isReload = false;
                state.status = 'failed';
            })
            .addCase(stopAccountEmployeeTimeEntryTimerAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(stopAccountEmployeeTimeEntryTimerAsync.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isReload = true;
                state.autoTimer = false;
                state.status = 'idle';
                state.lastEntryTimerId = 0;
                state.hoursRedux = 0;
                state.minutesRedux = 0;
                state.secondsRedux = 0;
                state.timeEntryIdForTimer = 0;
                state.timerObject = [
                    {
                        "hours": 0,
                        "minutes": 0,
                        "seconds": 0
                    }
                ];
                state.isTimerCloseWithNoEntry = false;
            })
            .addCase(stopAccountEmployeeTimeEntryTimerAsync.rejected, (state) => {
                state.isLoading = false;
                state.isReload = false;
                state.status = 'failed';
            })
            .addCase(deleteAccountEmployeeTimeEntryTimerAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAccountEmployeeTimeEntryTimerAsync.fulfilled, (state, action) => {
                state.isReload = true;
                state.autoTimer = false;
                state.status = 'idle';
                state.lastEntryTimerId = 0;
                state.hoursRedux = 0;
                state.minutesRedux = 0;
                state.secondsRedux = 0;
                state.timeEntryIdForTimer = 0;
                state.timerObject = [
                    {
                        "hours": 0,
                        "minutes": 0,
                        "seconds": 0
                    }
                ];
                state.isTimerCloseWithNoEntry = true;
            })
            .addCase(deleteAccountEmployeeTimeEntryTimerAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(updateTimeEntriesAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateTimeEntriesAsync.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
                const { RowId } = action.payload as any;
                const rowIndex = state.timeEntriesList.findIndex(x => x.rowId == RowId);
                let tempToday = Number(getDecimalFromTime(state.todayHours, state.decimalFormat));
                let tempTotal = Number(getDecimalFromTime(state.totalHours, state.decimalFormat));
                let tempBillableHours = Number(getDecimalFromTime(state.billableHours, state.decimalFormat));
                let tempNonBillableHours = Number(getDecimalFromTime(state.nonBillableHours, state.decimalFormat));

                let isDeleted = action.meta.arg.IsDelete;
                let totalToday = state.timeEntriesList.reduce((a, b) => {
                    if (b.AccountProjectTaskId != null) {
                        b.timeEntries.map((item: any) => {
                            // if ((item.rowId === RowId) && b.AccountProjectTaskId != action.meta.arg.AccountProjectTaskId && action.meta.arg.IsBillable !== true) {
                            //     if (Number(b.IsBillable) === 1) {
                            //         tempBillableHours = tempBillableHours - item.Hours;
                            //         tempNonBillableHours = tempNonBillableHours + item.Hours;
                            //     } else {                            //          
                            //         tempBillableHours = tempBillableHours + item.Hours;
                            //         tempNonBillableHours = tempNonBillableHours - item.Hours;
                            //     }
                            // }
                            if ((item.rowId === RowId) && b.AccountProjectTaskId != action.meta.arg.AccountProjectTaskId) {
                                const oldIsBillable = Number(b.IsBillable) === 1;
                                const newIsBillable = Number(action.meta.arg.IsBillable) === 1;

                                if (oldIsBillable !== newIsBillable) {
                                    if (newIsBillable) {
                                        tempBillableHours = tempBillableHours + item.Hours;
                                        tempNonBillableHours = tempNonBillableHours - item.Hours;
                                    } else {
                                        tempBillableHours = tempBillableHours - item.Hours;
                                        tempNonBillableHours = tempNonBillableHours + item.Hours;
                                    }
                                }
                            }
                            if ((item.rowId === RowId) && isDeleted) {
                                if (item.AccountEmployeeTimeEntryId != null && (moment(new Date()).format("YYYY-MM-DD") == item.TimeEntryDate)) {
                                    tempToday = tempToday + item.Hours;
                                }
                                if (Number(b.IsBillable) === 1) {
                                    tempBillableHours = tempBillableHours - item.Hours;
                                } else {
                                    tempNonBillableHours = tempNonBillableHours - item.Hours;
                                }
                                tempTotal = tempTotal - item.Hours;
                                state.decimalTotalHours = state.decimalTotalHours - item.Hours;
                            }
                        })
                    }
                    return tempToday;
                }, 0);
                if (isDeleted) {
                    state.timeEntriesList.splice(rowIndex, 1);
                    state.todayHours = displayValueForTimeEntry(totalToday, state.isTimesheetPolicy, state.decimalFormat).toString();
                    state.totalHours = displayValueForTimeEntry(tempTotal, state.isTimesheetPolicy, state.decimalFormat).toString();
                }
                state.billableHours = displayValueForTimeEntry(tempBillableHours, state.isTimesheetPolicy, state.decimalFormat).toString();
                state.nonBillableHours = displayValueForTimeEntry(tempNonBillableHours, state.isTimesheetPolicy, state.decimalFormat).toString();
                ////////////////////////////////
                // let tempToday = Number(state.todayHours)
                // let tempTotal = Number(state.totalHours)
                // let tempBillableHours = Number(state.billableHours)
                // let tempNonBillableHours = Number(state.nonBillableHours)
                // state.timeEntriesList.reduce((a, b) => {
                //     if (b.AccountProjectTaskId != null) {
                //         b.timeEntries.map((item: any) => {
                //             if (item.AccountEmployeeTimeEntryId != null && (item.rowId === RowId)) {
                //                 if (moment(new Date()).format("YYYY-MM-DD") == item.TimeEntryDate) {
                //                     tempToday = tempToday - item.Hours;
                //                 }
                //                 if (b.IsBillable == 1) {
                //                     tempBillableHours = tempBillableHours - item.Hours
                //                 } else {
                //                     tempNonBillableHours = tempNonBillableHours - item.Hours
                //                 }
                //                 tempTotal = tempTotal - item.Hours;
                //             }
                //         });
                //     }
                // }, 0);
                // state.timeEntriesList.splice(rowIndex, 1);
                // state.todayHours = displayValueForTimeEntry(tempToday, state.isTimesheetPolicy, state.decimalFormat).toString();
                // state.totalHours = displayValueForTimeEntry(tempTotal, state.isTimesheetPolicy, state.decimalFormat).toString();
                // state.billableHours = displayValueForTimeEntry(tempBillableHours, state.isTimesheetPolicy, state.decimalFormat).toString();
                // state.nonBillableHours = displayValueForTimeEntry(tempNonBillableHours, state.isTimesheetPolicy, state.decimalFormat).toString();
                ////////////////////////////////
            })
            .addCase(updateTimeEntriesAsync.rejected, (state, action) => {
                state.status = 'failed'
            })
            .addCase(updateTimesheetPeriodAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateTimesheetPeriodAsync.fulfilled, (state, action) => {
                state.status = 'idle';
            })
            .addCase(updateTimesheetPeriodAsync.rejected, (state, action) => {
                state.status = 'failed'
            })
            .addCase(submittedTimesheetAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(submittedTimesheetAsync.fulfilled, (state, action) => {
                state.status = 'idle';
                const response = <any>action.payload;
                // is error undefined
                if (response.result[0].IsError == undefined) {
                    //state.submittedDate = moment.parseZone(response.result[0].SubmittedDate).format("YYYY-MM-DD");
                    state.submittedDate = response.result[0].SubmittedDate
                    state.timesheetStatus = setTimesheetStatus(response.result[0].Approved, response.result[0].Rejected, response.result[0].Submitted);
                    // state.isLocked = (state.timesheetStatus.text == 'Approved' || 'Submitted') ? true : false;
                    state.isLocked = (response.lockApprovedRecords == true && state.timesheetStatus.text == 'Approved') || (response.lockSubmittedRecords == true && state.timesheetStatus.text == 'Submitted') ? true : false;
                    state.isSubmitted = Boolean(response.result[0].Submitted) || Boolean(response.result[0].Rejected) || Boolean(response.result[0].Approved);
                    state.timeEntriesList.map(item => {
                        if (item.AccountEmployeeTimeEntryApprovalProjectId != null) {
                            item.timeEntries.map((x: any) => {
                                if (x.AccountEmployeeTimeEntryId != null) {
                                    x.status = state.timesheetStatus.text == "Approved" ? "record-approved" : "record-submitted";
                                }
                            });
                        }
                    });
                } else {
                }
                state.isLoading = false;
            })
            .addCase(submittedTimesheetAsync.rejected, (state, action) => {
                state.status = 'failed'
                state.isLoading = false;
            })
            .addCase(UpdateTimesheetPeriodListForPeriodStatusAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(UpdateTimesheetPeriodListForPeriodStatusAsync.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
                if (action.payload.status == 0) {
                    let serverResponse = action.payload.json[0].accountemployeetimeentryperiodid_Update.split(',');
                    serverResponse.forEach(function (index: number) {
                        let masterRowIndex = state.timeSheetPeriodList.findIndex((record) => record.AccountEmployeeTimeEntryPeriodId === serverResponse[index]);
                        state.timeSheetPeriodList.splice(masterRowIndex, 1);
                    });
                } else {
                    action.payload.json.forEach(function (item: any) {
                        let masterRowIndex = state.timeSheetPeriodList.findIndex((record) => record.AccountEmployeeTimeEntryPeriodId === item.AccountEmployeeTimeentryPeridID);
                        state.timeSheetPeriodList.splice(masterRowIndex, 1);
                    });
                }
            })
            .addCase(UpdateTimesheetPeriodListForPeriodStatusAsync.rejected, (state, action) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(ApproveTimesheetForMobileAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoadingApproval = true;
            })
            .addCase(ApproveTimesheetForMobileAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReloadApproval = true;
                state.isLoadingApproval = false;

            })
            .addCase(ApproveTimesheetForMobileAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoadingApproval = false;
            })
            .addCase(RejectTimesheetForMobileAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoadingApproval = true;
            })
            .addCase(RejectTimesheetForMobileAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReloadApproval = true;
                state.isLoadingApproval = false;
            })
            .addCase(RejectTimesheetForMobileAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoadingApproval = false;
            })
            .addCase(SingleApprovedTimesheetTimeOffForMobileAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoadingApproval = true;
            })
            .addCase(SingleApprovedTimesheetTimeOffForMobileAsync.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoadingApproval = false;
                state.isReloadApproval = true;
            })
            .addCase(SingleApprovedTimesheetTimeOffForMobileAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoadingApproval = false;
            })
            .addCase(SingleRejectTimesheetTimeOffForMobileAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoadingApproval = true;
            })
            .addCase(SingleRejectTimesheetTimeOffForMobileAsync.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isReloadApproval = true;
                state.isLoadingApproval = false;
            })
            .addCase(SingleRejectTimesheetTimeOffForMobileAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoadingApproval = false;
            })
            .addCase(ApprovedSelectedTimesheetTimeOffForMobileAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoadingApproval = true;
            })
            .addCase(ApprovedSelectedTimesheetTimeOffForMobileAsync.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isReloadApproval = true;
                state.isLoadingApproval = false;
            })
            .addCase(ApprovedSelectedTimesheetTimeOffForMobileAsync.rejected, (state) => {
                state.status = 'failed'
                state.isLoadingApproval = false;
            })
            .addCase(RejectSelectedTimesheetTimeOffForMobileAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoadingApproval = true;
            })
            .addCase(RejectSelectedTimesheetTimeOffForMobileAsync.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isReloadApproval = true;
                state.isLoadingApproval = false;
            })
            .addCase(RejectSelectedTimesheetTimeOffForMobileAsync.rejected, (state) => {
                state.status = 'failed'
                state.isLoadingApproval = false;
            })
            .addCase(SingleApproveTimesheetForMobileAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoadingApproval = true;
            })
            .addCase(SingleApproveTimesheetForMobileAsync.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoadingApproval = false;
                state.isReloadApproval = true;
                /*                 action.payload.map((item: any) => {
                                    item.isSelected = false;
                                }); */
                /* state.timeSheetPeriodList = !("Message" in action.payload[0]) ? action.payload : []; */
            })
            .addCase(SingleApproveTimesheetForMobileAsync.rejected, (state) => {
                state.status = 'failed'
                state.timeSheetPeriodList = [];
                state.isLoadingApproval = false;
            })
            .addCase(SingleApproveOrRejectAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoadingApproval = true;
            })
            .addCase(SingleApproveOrRejectAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReloadApproval = true;
                state.isLoadingApproval = false;
            })
            .addCase(SingleApproveOrRejectAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoadingApproval = false;
            })
            .addCase(SendToXero.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
                state.isReload = false;
            })
            .addCase(SendToXero.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                //state.isReload = true;
                state.timeSheetPeriodIds = [];
                state.isAllChecked = false;
            })
            .addCase(SendToXero.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
                state.isReload = false;
            })
            .addCase(getTimesheetTemplateAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
                state.isReload = false;
            })
            .addCase(getTimesheetTemplateAsync.fulfilled, (state, action) => {
                state.status = 'idle';
                let newArr = [...state.timeEntriesList];
                if (!action.payload[0].hasOwnProperty('Message')) {
                    action.payload.forEach((values: any) => {
                        let rowId = newArr.length;
                        let newRowId = 1;
                        if (rowId > 0) {
                            newRowId = Math.max(...newArr.map(member => member.rowId)) + 1;
                        }
                        let newRow = { ...newArr[0], ...values, rowId: newRowId };
                        newRow.timeEntries = newRow.timeEntries.map((x: any) => {
                            return { ...x, rowId: newRowId };
                        });
                        newArr.push(newRow);
                    });
                    let filteredArr = newArr.filter((item) => {
                        return item.rowId === 0 || (item.AccountClientId !== null || item.isTimeOff === true);
                    });
                    let rowId = filteredArr.length;
                    let newRowId = rowId > 0 ? Math.max(...filteredArr.map(member => member.rowId)) + 1 : 1;
                    for (let i = 0; i < state.numberOfBlankRowsInTimesheet; i++) {
                        let newRow = { ...newArr[0], rowId: newRowId + i };
                        newRow.timeEntries = newRow.timeEntries.map((x: any) => ({
                            ...x,
                            rowId: newRowId + i
                        }));
                        filteredArr.push(newRow);
                    }
                    state.timeEntriesList = filteredArr;
                }
                state.isLoading = false;
            })
            // .addCase(getTimesheetTemplateAsync.fulfilled, (state, action) => {
            //     state.status = 'idle';
            //     let newArr = [...state.timeEntriesList];
            //     //////
            //     // let rowId = newArr.length;
            //     // let newRowId = 1;
            //     // if (rowId > 0) {
            //     //     newRowId = Math.max(...newArr.map(member => member.rowId)) + 1;
            //     // }
            //     // let newRow = { ...newArr[0], ...newValues, rowId: newRowId };
            //     // newRow.timeEntries = newRow.timeEntries.map((x: any) => {
            //     //     return { ...x, rowId: newRowId };
            //     // });
            //     // newArr.push(newRow);
            //     // state.timeEntriesList = newArr;
            //     //////
            //     if (!action.payload[0].hasOwnProperty('Message')) {
            //         action.payload.forEach((values: any) => {
            //             let rowId = newArr.length;
            //             let newRowId = 1;
            //             if (rowId > 0) {
            //                 newRowId = Math.max(...newArr.map(member => member.rowId)) + 1;
            //             }
            //             let newRow = { ...newArr[0], ...values, rowId: newRowId };
            //             newRow.timeEntries = newRow.timeEntries.map((x: any) => {
            //                 return { ...x, rowId: newRowId };
            //             });
            //             newArr.push(newRow);
            //         });
            //         state.timeEntriesList = newArr;
            //     }
            //     state.isLoading = false;
            // })
            .addCase(getTimesheetTemplateAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
                state.isReload = false;
            })
             .addCase(getTimesheetPriod.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getTimesheetPriod.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
                action.payload.map((item: any) => {
                    item.isSelected = false;
                });
                state.timeSheetPeriodList = !("Message" in action.payload[0]) ? action.payload : [];
            })
            .addCase(getTimesheetPriod.rejected, (state) => {
                state.status = 'failed'
                state.timeSheetPeriodList = [];
                state.isLoading = false;
            })
            .addCase(getTimesheetApprovalsFilters.pending, (state) => {
                state.status = 'loading';
                state.isLoadingApproval = true;
            })
            .addCase(getTimesheetApprovalsFilters.fulfilled, (state, action) => {

                if (action.payload != undefined) {
                    state.timesheetApprovalList = JSON.parse(action.payload.data);
                    state.timesheetApprovalList.map((item: any) => {
                        item.isSelected = 0
                    });
                } else {
                    state.timesheetApprovalList = [];
                }
                if (JSON.parse(action.payload.Employeesdata).length === 0) {
                    state.Employeesdata = [];
                }
                else {
                    state.Employeesdata = JSON.parse(action.payload.Employeesdata);
                    state.Employeesdata.map((item: any) => {
                        item.value = item.TimeEntryAccountEmployeeId;
                        item.label = item.EmployeeName;
                        item.isSelected = 0;
                    });
                }
                 state.isLoadingApproval = false;
                //state.isForTimesheet = false;
            })
            .addCase(getTimesheetApprovalsFilters.rejected, (state) => {
                state.status = 'failed';
                state.isLoadingApproval = false;
            })
    }
})

export const {
    updateIsCanvasLoading,
    updateSearchPagination,
    updatePagination,
    updateCurrentDate,
    updateAccountEmployeeId,
    updateMasterFieldsByRowId,
    updateDetailFieldsByDetailRowId,
    removeTimeEntryRow,
    addBlankTimeEntryRow,
    updateIsReload,
    updateIsLoading,
    addBlankTimeOffRow,
    updateInValidTimeError,
    updateValidTimeError,
    updateCopyTimesheetState,
    updateAllSelectedAndUnSelected,
    updateSelectedResource,
    updateUnSelectedResource,
    updateDescription,
    updateTimerTimesheet,
    updateTimerTimesheetState,
    updateTimesheetApprovalStatusId,
    updateTimesheetEnteredTypeId,
    updateIncludeDateRange,
    updateIncludePeriodListDateRange,
    updateTimesheetPeriodListEmpId,
    updateTimesheetFilterDates,
    updateTimesheetPeriodSelection,
    updateTimesheetPeriodBulkSelection,
    setApproved,
    setRejected,
    checkedState,
    unCheckedState,
    checkedAllState,
    unCheckedAllState,
    setDateRangeValue,
    filterTimeOffApproval,
    setOptionApproverEmployeeValue,
    updateTimesheetApprovalListEmpId,
    updateTimesheetApprovalListProjectId,
    setApprovedTimeOff,
    checkedAllStatetimeoff,
    unCheckedAllStatetimeoff,
    checkedStatetimeoff,
    unCheckedStatetimeoff,
    setComments,
    setCommentsTimeOff,
    updateValuesFromGlobalState,
    updateApprovalAccountProjectId,
    updateAccountEmployeeIdFromApproval,
    updateTimesheetApprovalFilterDates,
    updateToReoladTimesheetApproval,
    updateTabIndex,
    updateTimeEntryPeriodIdForPrint,
    updateTimesheetApprovalDataForPrint,
    updateTimesheetAttachment,
    updateApprovalDetails,
    updateRefreshPrint,
    updateTimesheetOff,
    setTimeSheetPeriodIdsState,
    setAllTimeSheetPeriodIdsState,
    resetSelectedRecordObjectInState,
    updateTimerFromNavbarState,
    updateStopTimerTimesheet,
    updateLockingDateArray,
    setSelectedEmployee,
    updateTimesheetScrollButton,
    updateIsStateHour,
    updateIsStateMinute,
    UpdateRefreshApi,
    resetFiltersState,
    resetTimerState,
    setTimerPulsing
} = timesheetSlice.actions

export const TimesheetState = (state: RootState) => state.timesheet;
export default timesheetSlice.reducer;